[
  {
    "id": "ai",
    "url": "/ai",
    "permission": "basic:permission",
    "isAI": true,
    "page": {
      "title": {
        "pt-BR": "Cobli IA",
        "en-US": "Cobli AI"
      },
      "description": {
        "pt-BR": "Cobli IA",
        "en-US": "Cobli AI"
      },
      "favorite": false,
      "infoUrl": "https://manual.cobli.co/docs/painel/cobli-ia"
    },
    "sidebar": {
      "icon": "sparkles",
      "title": {
        "pt-BR": "Cobli IA",
        "en-US": "Cobli AI"
      },
      "active": false
    },
    "featureFlag": "aiChat",
    "header": {
      "filterGroup": false
    },
    "routes": [
      {
        "id": "ai",
        "url": "/ai",
        "permission": "basic:permission",
        "featureFlag": "aiChat",
        "page": {
          "title": {
            "pt-BR": "IA",
            "en-US": "AI"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/cobli-ia"
        },
        "sidebar": {
          "icon": "sparkles",
          "title": {
            "pt-BR": "IA",
            "en-US": "AI"
          },
          "hide": true
        },
        "team": {
          "id": "ai",
          "name": "AI",
          "channels": {
            "slack-help": "help-tech-ai"
          }
        }
      },
      {
        "id": "ai-files",
        "url": "/ai/files",
        "permission": "basic:permission",
        "featureFlag": "aiChat",
        "page": {
          "title": {
            "pt-BR": "Arquivos",
            "en-US": "Files"
          },
          "description": {
            "pt-BR": "Gerencie os arquivos enviados para a IA.",
            "en-US": "Manage files uploaded to the AI."
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/cobli-ia/gerenciar-arquivos"
        },
        "sidebar": {
          "icon": "files",
          "title": {
            "pt-BR": "Arquivos",
            "en-US": "Files"
          },
          "hide": true
        },
        "team": {
          "id": "ai",
          "name": "AI",
          "channels": {
            "slack-help": "help-tech-ai"
          }
        }
      },
      {
        "id": "ai-trust",
        "url": "/ai/trust",
        "permission": "basic:permission",
        "featureFlag": "aiChat",
        "page": {
          "title": {
            "pt-BR": "Confiança e segurança",
            "en-US": "Trust and security"
          },
          "description": {
            "pt-BR": "Como a Cobli IA cuida da segurança, privacidade e controle dos seus dados.",
            "en-US": "How Cobli AI handles the security, privacy, and control of your data."
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/cobli-ia/confianca-e-seguranca"
        },
        "sidebar": {
          "icon": "shield-check",
          "title": {
            "pt-BR": "Confiança e segurança",
            "en-US": "Trust and security"
          },
          "hide": true
        },
        "team": {
          "id": "ai",
          "name": "AI",
          "channels": {
            "slack-help": "help-tech-ai"
          }
        }
      }
    ],
    "team": {
      "id": "ai",
      "name": "AI",
      "channels": {
        "slack-help": "help-tech-ai"
      }
    }
  },
  {
    "id": "home",
    "redirect": "/home",
    "permission": "basic:permission",
    "page": {
      "title": {
        "pt-BR": "Bem vindo ao Painel!",
        "en-US": "Welcome to the Dashboard!"
      },
      "description": {
        "pt-BR": "Página inicial do dashboard com visão geral das principais métricas da frota",
        "en-US": "Dashboard home page with overview of main fleet metrics"
      },
      "favorite": false,
      "infoUrl": "https://manual.cobli.co/docs/painel/comece-aqui/boas-vindas"
    },
    "sidebar": {
      "icon": "house",
      "title": {
        "pt-BR": "Início",
        "en-US": "Home"
      },
      "active": true
    },
    "header": {
      "filterGroup": true
    },
    "routes": [
      {
        "id": "home-root",
        "url": "/home",
        "page": {
          "title": {
            "pt-BR": "Bem vindo ao Painel!",
            "en-US": "Welcome to the Dashboard!"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/comece-aqui/boas-vindas",
          "favorite": false,
          "description": {
            "pt-BR": "Página inicial do dashboard com visão geral das principais métricas da frota",
            "en-US": "Dashboard home page with overview of main fleet metrics"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "house",
          "title": {
            "pt-BR": "Início",
            "en-US": "Home"
          },
          "active": true
        },
        "permission": "basic:permission",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "area-cliente-root",
        "url": "/business-manager",
        "featureFlag": "businessManager",
        "page": {
          "title": {
            "pt-BR": "Área do cliente",
            "en-US": "Customer Area"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/area-do-cliente",
          "favorite": false,
          "description": {
            "pt-BR": "Área do cliente",
            "en-US": "Customer Area"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "building",
          "title": {
            "pt-BR": "Área do cliente",
            "en-US": "Customer Area"
          },
          "active": false
        },
        "permission": "basic:permission",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "basic-value",
        "url": "/basic-value",
        "permission": [
          "create-update-delete:crm",
          "create-update-delete:vehicle",
          "create-update-delete:driver",
          "create-update-delete:users-and-invites",
          "config-and-view:custom-alerts",
          "create-update-delete:places-of-interest",
          "full-control:checklist"
        ],
        "isOnboardingFleet": true,
        "page": {
          "title": {
            "pt-BR": "Guia de configuração",
            "en-US": "Setup guide"
          },
          "description": {
            "pt-BR": "Configure sua frota e extraia o máximo da Cobli.",
            "en-US": "Set up your fleet and get the most out of Cobli."
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/comece-aqui/primeiros-passos"
        },
        "header": {
          "filterGroup": false
        },
        "sidebar": {
          "icon": "flag",
          "title": {
            "pt-BR": "Guia de configuração",
            "en-US": "Setup guide"
          },
          "active": false
        }
      },
      {
        "id": "component-most-visited-menu",
        "header": {
          "filterGroup": true
        },
        "component": "most-visited-menu",
        "sidebar": {
          "hide": true,
          "icon": "map",
          "title": {
            "pt-BR": "Início",
            "en-US": "Home"
          },
          "active": true
        },
        "permission": "basic:permission",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      }
    ],
    "team": {
      "id": "gf-core",
      "name": "GF-Core",
      "channels": {
        "slack-help": "help-tech-gf-core"
      }
    }
  },
  {
    "id": "operation",
    "page": {
      "title": {
        "pt-BR": "Operação",
        "en-US": "Operation"
      },
      "infoUrl": "https://cobli.com.br",
      "favorite": true,
      "description": {
        "pt-BR": "Ferramentas operacionais para monitoramento e controle da frota em tempo real",
        "en-US": "Operational tools for real-time fleet monitoring and control"
      }
    },
    "header": {
      "filterGroup": true
    },
    "routes": [
      {
        "id": "monitoring",
        "url": "/monitoring",
        "page": {
          "infoUrl": "https://manual.cobli.co/docs/painel/monitoramento",
          "favorite": true,
          "description": {
            "pt-BR": "Monitoramento da frota, visualize seus veículos e veja as atividades.",
            "en-US": "Fleet monitoring, visualize your vehicles and see activities."
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "map",
          "title": {
            "pt-BR": "Monitoramento",
            "en-US": "Monitoring"
          },
          "active": true
        },
        "permission": "basic:permission",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "alerts",
        "url": "/alerts",
        "support": {
          "uid": "alertas"
        },
        "page": {
          "title": {
            "pt-BR": "Alertas",
            "en-US": "Alerts"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/alertas",
          "favorite": true,
          "description": {
            "pt-BR": "Configure alertas da sua frota e monitore quando as configurações definidas forem descumpridas",
            "en-US": "Configure your fleet alerts and monitor when the defined settings are not met"
          }
        },
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "alerts-manage-create",
            "url": "/alerts/manage/create",
            "page": {
              "title": {
                "pt-BR": "Política de frota - Cadastrar",
                "en-US": "Fleet Policy - Create"
              },
              "description": {
                "pt-BR": "Cadastrar nova política de frota.",
                "en-US": "Create a new fleet policy."
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/alertas/criar-regra"
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Política de frota - Cadastrar",
                "en-US": "Fleet Policy - Create"
              }
            },
            "permission": "config-and-view:custom-alerts",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "alerts-manage-edit",
            "url": "/alerts/manage/edit",
            "page": {
              "title": {
                "pt-BR": "Política de frota - Editar",
                "en-US": "Fleet Policy - Edit"
              },
              "description": {
                "pt-BR": "Editar política de frota.",
                "en-US": "Edit fleet policy."
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/alertas/criar-regra"
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Política de frota - Editar",
                "en-US": "Fleet Policy - Edit"
              }
            },
            "permission": "config-and-view:custom-alerts",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "alerts-manage",
            "url": "/alerts/manage",
            "page": {
              "title": {
                "pt-BR": "Gerenciar alertas",
                "en-US": "Manage Alerts"
              },
              "description": {
                "pt-BR": "Visualize e configure todos os alertas da sua frota",
                "en-US": "View and configure all alerts for your fleet."
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/alertas/tipos-de-alerta"
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Gerenciar alertas",
                "en-US": "Manage Alerts"
              }
            },
            "permission": "config-and-view:custom-alerts",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "alerts-create",
            "url": "/alerts/create",
            "page": {
              "title": {
                "pt-BR": "Alertas - Cadastrar",
                "en-US": "Alerts - Register"
              },
              "description": {
                "pt-BR": "Cadastrar novo alerta.",
                "en-US": "Register new alert."
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/alertas/criar-regra"
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Alertas - Cadastrar",
                "en-US": "Alerts - Register"
              }
            },
            "permission": "config-and-view:custom-alerts",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "alerts-create-new",
            "url": "/alerts/create/:trigger",
            "page": {
              "title": {
                "pt-BR": "Criar novo alerta",
                "en-US": "Create new alert"
              },
              "description": {
                "pt-BR": "Configure as condições de monitoramento e como você quer ser notificado.",
                "en-US": "Configure the monitoring conditions and how you want to be notified."
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/alertas/criar-regra"
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Criar novo alerta",
                "en-US": "Create new alert"
              }
            },
            "permission": "config-and-view:custom-alerts",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "alerts-events-type",
            "url": "/alerts/events/:alertType",
            "page": {
              "title": {
                "pt-BR": "Eventos do alerta",
                "en-US": "Alert Events"
              },
              "favorite": true,
              "description": {
                "pt-BR": "Visualize todos os acionamentos deste alerta",
                "en-US": "View all triggers for this alert"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/alertas/historico"
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Alertas - Eventos",
                "en-US": "Alerts - Events"
              }
            },
            "permission": "config-and-view:custom-alerts",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "alerts-edit",
            "url": "/alerts/edit/:alertType",
            "page": {
              "title": {
                "pt-BR": "Editar Alerta",
                "en-US": "Edit Alert"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/alertas/criar-regra",
              "description": {
                "pt-BR": "Altere e salve sua regra de forma simples",
                "en-US": "Change and save your rule easily"
              }
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Alertas - Editar Alerta",
                "en-US": "Alerts - Edit Alert"
              }
            },
            "permission": "config-and-view:custom-alerts",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "siren",
          "title": {
            "pt-BR": "Alertas",
            "en-US": "Alerts"
          },
          "active": false
        },
        "permission": "config-and-view:custom-alerts",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "geofences",
        "url": "/geofences",
        "support": {
          "uid": "criando-locais-de-interesse2"
        },
        "page": {
          "infoUrl": "https://manual.cobli.co/docs/painel/geofences",
          "favorite": true,
          "title": {
            "pt-BR": "Locais de interesse",
            "en-US": "Interest locations"
          },
          "description": {
            "pt-BR": "Gerencie seus locais de interesse, visualize e edite",
            "en-US": "Manage your interest locations, visualize and edit your interest locations."
          }
        },
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "geofences-create",
            "url": "/geofences/create",
            "header": {
              "filterGroup": true
            },
            "page": {
              "title": {
                "pt-BR": "Criar local de interesse",
                "en-US": "Create interest location"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/geofences/criar-local"
            },
            "sidebar": {
              "hide": true
            },
            "permission": "view:places-of-interest",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "geofences-edit",
            "url": "/geofences/edit/:id",
            "page": {
              "title": {
                "pt-BR": "Editar local de interesse",
                "en-US": "Edit interest location"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/geofences/criar-local"
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true
            },
            "permission": "view:places-of-interest",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "map-pinned",
          "title": {
            "pt-BR": "Locais de interesse",
            "en-US": "Interest locations"
          },
          "active": true
        },
        "permission": "view:places-of-interest",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "tracking-history-root",
        "url": "/tracking-history",
        "page": {
          "title": {
            "pt-BR": "Trajetos",
            "en-US": "Routes"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/jornadas",
          "favorite": true,
          "description": {
            "pt-BR": "Resumo em linha do tempo dos trajetos realizados pelos veículos no dia anterior",
            "en-US": "Timeline summary of routes taken by vehicles the previous day"
          }
        },
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "tracking-history",
            "url": "/tracking",
            "page": {
              "title": {
                "pt-BR": "Trajetos",
                "en-US": "Routes"
              },
              "description": {
                "pt-BR": "Trajetos",
                "en-US": "Routes"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/jornadas"
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Trajetos",
                "en-US": "Routes"
              }
            },
            "permission": "basic:permission",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "route",
          "title": {
            "pt-BR": "Trajetos",
            "en-US": "Routes"
          },
          "active": false
        },
        "permission": "basic:permission",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "passage-history",
        "url": "/passage-history",
        "page": {
          "infoUrl": "https://manual.cobli.co/docs/painel/geofences/historico-de-passagens",
          "favorite": true,
          "description": {
            "pt-BR": "Consulte o histórico de passagem de veículos em locais específicos",
            "en-US": "Check the passage history of vehicles at specific locations"
          }
        },
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "passage-history-results",
            "url": "/passage-history/results",
            "page": {
              "title": {
                "pt-BR": "Resultados do histórico de passagem",
                "en-US": "Passage History Results"
              },
              "description": {
                "pt-BR": "Resultados da consulta de histórico de passagem",
                "en-US": "Passage history query results"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/geofences/historico-de-passagens"
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true
            },
            "permission": "view:places-of-interest",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "history",
          "title": {
            "pt-BR": "Histórico de passagem",
            "en-US": "Passage History"
          },
          "active": true
        },
        "permission": "view:places-of-interest",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "routing-root",
        "url": "/routing",
        "page": {
          "title": {
            "pt-BR": "Serviços e entregas",
            "en-US": "Services and Deliveries"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/servicos-e-entregas",
          "favorite": true,
          "description": {
            "pt-BR": "Organize suas entregas com rotas e atividades programadas",
            "en-US": "Organize your deliveries with routes and scheduled activities"
          }
        },
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "routing-activities",
            "url": "/routing/activities",
            "page": {
              "title": {
                "pt-BR": "Serviços e entregas",
                "en-US": "Services and Deliveries"
              },
              "description": {
                "pt-BR": "Organize suas entregas com rotas e atividades programadas",
                "en-US": "Organize your deliveries with routes and scheduled activities"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/servicos-e-entregas/acompanhar-atividades"
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Serviços e entregas",
                "en-US": "Services and Deliveries"
              }
            },
            "header": {
              "filterGroup": true
            },
            "permission": "view:routes",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "routing-routes",
            "url": "/routing/routes",
            "page": {
              "title": {
                "pt-BR": "Serviços e entregas",
                "en-US": "Services and Deliveries"
              },
              "description": {
                "pt-BR": "Organize suas entregas com rotas e atividades programadas",
                "en-US": "Organize your deliveries with routes and scheduled activities"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/servicos-e-entregas"
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Serviços e entregas",
                "en-US": "Services and Deliveries"
              }
            },
            "header": {
              "filterGroup": true
            },
            "permission": "view:routes",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "routing-planning",
            "url": "/routing/planning",
            "page": {
              "title": {
                "pt-BR": "Torre de controle",
                "en-US": "Control Tower"
              },
              "description": {
                "pt-BR": "Torre de controle",
                "en-US": "Control Tower"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/servicos-e-entregas/planejar-rotas"
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Torre de controle",
                "en-US": "Control Tower"
              }
            },
            "permission": "create-update-delete:routes",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "routing-edit",
            "url": "/routing/edit",
            "page": {
              "title": {
                "pt-BR": "Serviços e entregas",
                "en-US": "Services and Deliveries"
              },
              "description": {
                "pt-BR": "Organize suas entregas com rotas e atividades programadas",
                "en-US": "Organize your deliveries with routes and scheduled activities"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/servicos-e-entregas"
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Serviços e entregas",
                "en-US": "Services and Deliveries"
              }
            },
            "permission": "create-update-delete:routes",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "routing-activity-edit",
            "url": "/routing/activity-edit",
            "page": {
              "title": {
                "pt-BR": "Serviços e entregas",
                "en-US": "Services and Deliveries"
              },
              "description": {
                "pt-BR": "Organize suas entregas com rotas e atividades programadas",
                "en-US": "Organize your deliveries with routes and scheduled activities"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/servicos-e-entregas"
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Serviços e entregas - Editar",
                "en-US": "Services and Deliveries - Edit"
              }
            },
            "permission": "create-update-delete:routes",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "package",
          "title": {
            "pt-BR": "Serviços e entregas",
            "en-US": "Services and Deliveries"
          },
          "active": false
        },
        "permission": "view:routes",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "proof-of-conclusion",
        "url": "/proof-of-conclusion",
        "page": {
          "title": {
            "pt-BR": "Comprovantes",
            "en-US": "Proof of Completion"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/comprovantes",
          "favorite": true,
          "description": {
            "pt-BR": "Gestão de comprovantes das atividades planejadas",
            "en-US": "Management of proof of completion for planned activities"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "file-check",
          "title": {
            "pt-BR": "Comprovantes",
            "en-US": "Proof of Completion"
          },
          "active": false
        },
        "permission": "view:proof-of-conclusion",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "checklists",
        "url": "/checklist",
        "page": {
          "title": {
            "pt-BR": "Checklists",
            "en-US": "Checklists"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/checklists",
          "favorite": true,
          "description": {
            "pt-BR": "Crie, acompanhe e gerencie os checklists utilizados na sua frota",
            "en-US": "Create, track and manage checklists used in your fleet"
          }
        },
        "tabs": [
          {
            "id": "checklists-dashboard",
            "url": "/checklist/dashboard",
            "support": {
              "uid": "checklist"
            },
            "page": {
              "title": {
                "pt-BR": "Checklists",
                "en-US": "Checklists"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/checklists",
              "favorite": true,
              "description": {
                "pt-BR": "Crie, acompanhe e gerencie os checklists utilizados na sua frota",
                "en-US": "Create, track and manage checklists used in your fleet"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "title": {
                "pt-BR": "Checklists",
                "en-US": "Checklists"
              },
              "active": false
            },
            "permission": "full-control:checklist",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "routes": [
          {
            "id": "checklists-all",
            "url": "/checklist/all",
            "page": {
              "title": {
                "pt-BR": "Checklists",
                "en-US": "Checklists"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/checklists",
              "favorite": true,
              "description": {
                "pt-BR": "Organize e acompanhe todos os checklists da rotina operacional da sua frota",
                "en-US": "Organize and track all checklists from your fleet's operational routine"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Checklists",
                "en-US": "Checklists"
              },
              "active": false
            },
            "permission": "full-control:checklist",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "checklists-response",
            "url": "/checklist/response/:checklistId",
            "page": {
              "title": {
                "pt-BR": "Respostas",
                "en-US": "Responses"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/checklists/analisar-resultados",
              "favorite": true,
              "description": {
                "pt-BR": "Acompanhe todas as respostas enviadas pelos motoristas.",
                "en-US": "Track all responses sent by drivers."
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Respostas",
                "en-US": "Responses"
              },
              "active": false
            },
            "permission": "full-control:checklist",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "checklists-all-responses",
            "url": "/checklist/responses",
            "page": {
              "title": {
                "pt-BR": "Checklists",
                "en-US": "Checklists"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/checklists/analisar-resultados",
              "favorite": true,
              "description": {
                "pt-BR": "Acompanhe todas as respostas enviadas pelos motoristas, independentemente do checklist.",
                "en-US": "Track all responses sent by drivers, regardless of the checklist."
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Checklists",
                "en-US": "Checklists"
              },
              "active": false
            },
            "permission": "full-control:checklist",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "clipboard-check",
          "title": {
            "pt-BR": "Checklists",
            "en-US": "Checklists"
          },
          "active": false
        },
        "redirect": "/checklist/dashboard",
        "permission": "full-control:checklist",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "path-association",
        "url": "/path-association",
        "page": {
          "title": {
            "pt-BR": "Associação de trechos",
            "en-US": "Path Association"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/associacao-de-trechos",
          "favorite": true,
          "description": {
            "pt-BR": "Gerencie a associação de motoristas aos trechos das viagens",
            "en-US": "Manage driver association to route segments"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "spline",
          "title": {
            "pt-BR": "Associação de trechos",
            "en-US": "Path Association"
          },
          "active": false
        },
        "permission": "basic:permission",
        "featureFlag": "enableDriverAssociationPast",
        "routes": [
          {
            "id": "path-association-vehicle",
            "url": "/path-association/vehicle/:vehicleId",
            "page": {
              "title": {
                "pt-BR": "Trechos",
                "en-US": "Route Segments"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/associacao-de-trechos/associar-motorista-a-trechos"
            },
            "sidebar": {
              "hide": true
            },
            "permission": "basic:permission",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "isSafetyCoacher": false,
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      }
    ],
    "sidebar": {
      "icon": "map",
      "title": {
        "pt-BR": "Operação",
        "en-US": "Operation"
      },
      "active": false
    },
    "redirect": "/monitoring",
    "permission": "basic:permission",
    "team": {
      "id": "gf-core",
      "name": "GF-Core",
      "channels": {
        "slack-help": "help-tech-gf-core"
      }
    }
  },
  {
    "id": "security",
    "page": {
      "title": {
        "pt-BR": "Segurança",
        "en-US": "Security"
      },
      "infoUrl": "https://manual.cobli.co/docs/painel/seguranca",
      "favorite": true,
      "description": {
        "pt-BR": "Gerencie a segurança da sua frota",
        "en-US": "Manage your fleet security"
      }
    },
    "header": {
      "filterGroup": true
    },
    "routes": [
      {
        "id": "visao-geral-seguranca",
        "page": {
          "title": {
            "pt-BR": "Visão geral",
            "en-US": "Overview"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/seguranca/visao-geral",
          "favorite": true,
          "description": {
            "pt-BR": "Dashboard com visão geral das métricas de segurança da frota",
            "en-US": "Dashboard with overview of fleet security metrics"
          }
        },
        "tabs": [
          {
            "id": "visao-geral-veiculo",
            "url": "/safety/dashboard/ranking/vehicle",
            "page": {
              "title": {
                "pt-BR": "Visão geral",
                "en-US": "Overview"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/seguranca/visao-geral",
              "favorite": true,
              "description": {
                "pt-BR": "Dashboard com visão geral das métricas de segurança da frota",
                "en-US": "Dashboard with overview of fleet security metrics"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "shield",
              "title": {
                "pt-BR": "Visão geral",
                "en-US": "Overview"
              },
              "active": false
            },
            "permission": "view:fleet-safety",
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          },
          {
            "id": "visao-geral-motorista",
            "url": "/safety/dashboard/ranking/driver",
            "page": {
              "title": {
                "pt-BR": "Visão geral",
                "en-US": "Overview"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/seguranca/visao-geral",
              "favorite": true,
              "description": {
                "pt-BR": "Dashboard com visão geral das métricas de segurança da frota",
                "en-US": "Dashboard with overview of fleet security metrics"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "shield",
              "title": {
                "pt-BR": "Visão geral",
                "en-US": "Overview"
              },
              "active": false
            },
            "permission": "view:fleet-safety",
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          }
        ],
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "shield",
          "title": {
            "pt-BR": "Visão geral",
            "en-US": "Overview"
          },
          "active": false
        },
        "redirect": "/safety/dashboard/ranking/vehicle",
        "permission": "view:fleet-safety",
        "featureFlag": "safetyRankingDash",
        "team": {
          "id": "video-xp",
          "name": "Video XP",
          "channels": {
            "slack-help": "help-tech-coblicam"
          }
        }
      },
      {
        "id": "cobli-cam-landing",
        "url": "/camera",
        "page": {
          "title": {
            "pt-BR": "Cobli Cam",
            "en-US": "Cobli Cam"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam"
        },
        "sidebar": {
          "icon": "video",
          "title": {
            "pt-BR": "Cobli Cam",
            "en-US": "Cobli Cam"
          }
        },
        "permission": "basic:permission",
        "hasCameraFlag": false,
        "team": {
          "id": "video-health",
          "name": "Video Health",
          "channels": {
            "slack-help": "help-tech-coblicam"
          }
        }
      },
      {
        "id": "eventos-de-video",
        "url": "",
        "page": {
          "title": {
            "pt-BR": "Eventos de vídeo",
            "en-US": "Video Events"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/eventos-de-video",
          "favorite": true,
          "description": {
            "pt-BR": "Análise e gerenciamento de eventos capturados pelas câmeras da frota",
            "en-US": "Analysis and management of events captured by fleet cameras"
          }
        },
        "tabs": [
          {
            "id": "eventos-de-video-dashboard",
            "url": "/camera/events/dashboard",
            "page": {
              "title": {
                "pt-BR": "Eventos de vídeo",
                "en-US": "Video Events"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/eventos-de-video",
              "favorite": true,
              "description": {
                "pt-BR": "Acompanhe, organize e analise os eventos de vídeo gerados pelas câmeras",
                "en-US": "Track, organize and analyze video events generated by cameras"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Eventos de vídeo",
                "en-US": "Video Events"
              },
              "active": false
            },
            "permission": "view:camera-media",
            "team": {
              "id": "video-health",
              "name": "Video Health",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          },
          {
            "id": "eventos-de-video-lista",
            "url": "/camera/events",
            "page": {
              "title": {
                "pt-BR": "Eventos de vídeo",
                "en-US": "Video Events"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/eventos-de-video",
              "favorite": true,
              "description": {
                "pt-BR": "Acompanhe, organize e analise os eventos de vídeo gerados pelas câmeras",
                "en-US": "Track, organize and analyze video events generated by cameras"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Eventos de vídeo",
                "en-US": "Video Events"
              },
              "active": false
            },
            "permission": "view:camera-media",
            "team": {
              "id": "video-health",
              "name": "Video Health",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          },
          {
            "id": "eventos-de-video-favoritos",
            "url": "/camera/events/favorites",
            "page": {
              "title": {
                "pt-BR": "Eventos de vídeo",
                "en-US": "Video Events"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/eventos-de-video",
              "favorite": true,
              "description": {
                "pt-BR": "Acompanhe, organize e analise os eventos de vídeo gerados pelas câmeras",
                "en-US": "Track, organize and analyze video events generated by cameras"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Eventos de vídeo",
                "en-US": "Video Events"
              },
              "active": false
            },
            "permission": "view:camera-media",
            "team": {
              "id": "video-health",
              "name": "Video Health",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          }
        ],
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "detalhes-do-evento-de-video",
            "url": "/camera/events/:mediaId",
            "page": {
              "title": {
                "pt-BR": "Eventos de vídeo",
                "en-US": "Video Events"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/eventos-de-video",
              "favorite": true,
              "description": ""
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Eventos de vídeo",
                "en-US": "Video Events"
              },
              "active": false
            },
            "permission": "view:camera-media",
            "team": {
              "id": "video-health",
              "name": "Video Health",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          }
        ],
        "sidebar": {
          "hide": false,
          "icon": "video",
          "title": {
            "pt-BR": "Eventos de vídeo",
            "en-US": "Video Events"
          },
          "active": false
        },
        "redirect": "/camera/events",
        "permission": "view:camera-media",
        "hasCameraFlag": true,
        "isSafetyCoacher": false,
        "team": {
          "id": "video-health",
          "name": "Video Health",
          "channels": {
            "slack-help": "help-tech-coblicam"
          }
        }
      },
      {
        "id": "videos-solicitados-root",
        "url": "/camera/requests",
        "page": {
          "title": {
            "pt-BR": "Vídeos solicitados",
            "en-US": "Requested Videos"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/videos-solicitados",
          "favorite": true,
          "description": {
            "pt-BR": "Acompanhe, revise e organize vídeos solicitados",
            "en-US": "Track, review and organize requested videos"
          }
        },
        "tabs": [
          {
            "id": "videos-solicitados-manuais",
            "url": "/camera/requests",
            "page": {
              "title": {
                "pt-BR": "Vídeos solicitados",
                "en-US": "Requested Videos"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/videos-solicitados",
              "favorite": true,
              "description": {
                "pt-BR": "Acompanhe, revise e organize vídeos solicitados",
                "en-US": "Track, review and organize requested videos"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "icon": "file-video",
              "title": {
                "pt-BR": "Vídeos solicitados - Manuais",
                "en-US": "Requested Videos - Manual"
              },
              "active": false
            },
            "permission": "view:camera-media",
            "team": {
              "id": "video-health",
              "name": "Video Health",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          },
          {
            "id": "videos-solicitados-automaticos",
            "url": "/camera/requests/automatic",
            "page": {
              "title": {
                "pt-BR": "Vídeos solicitados",
                "en-US": "Requested Videos"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/videos-solicitados",
              "favorite": true,
              "description": {
                "pt-BR": "Acompanhe, revise e organize vídeos solicitados",
                "en-US": "Track, review and organize requested videos"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "icon": "file-video",
              "title": {
                "pt-BR": "Vídeos solicitados",
                "en-US": "Requested Videos"
              },
              "active": false
            },
            "permission": "view:camera-media",
            "team": {
              "id": "video-health",
              "name": "Video Health",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          },
          {
            "id": "videos-solicitados-favoritos",
            "url": "/camera/requests/favorites",
            "page": {
              "title": {
                "pt-BR": "Vídeos solicitados",
                "en-US": "Requested Videos"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/videos-solicitados",
              "favorite": true,
              "description": {
                "pt-BR": "Acompanhe, revise e organize vídeos solicitados",
                "en-US": "Track, review and organize requested videos"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "icon": "file-video",
              "title": {
                "pt-BR": "Vídeos solicitados",
                "en-US": "Requested Videos"
              },
              "active": false
            },
            "permission": "view:camera-media",
            "team": {
              "id": "video-health",
              "name": "Video Health",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          }
        ],
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "detalhes-do-video-solicitado",
            "url": "/camera/requests/:mediaId",
            "page": {
              "title": {
                "pt-BR": "Vídeos solicitados",
                "en-US": "Requested Videos"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/videos-solicitados",
              "favorite": false,
              "description": ""
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Vídeos solicitados",
                "en-US": "Requested Videos"
              },
              "active": false
            },
            "permission": "view:camera-media",
            "team": {
              "id": "video-health",
              "name": "Video Health",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          }
        ],
        "sidebar": {
          "hide": false,
          "icon": "file-video",
          "title": {
            "pt-BR": "Vídeos solicitados",
            "en-US": "Requested Videos"
          },
          "active": false
        },
        "permission": "view:camera-media",
        "hasCameraFlag": true,
        "isSafetyCoacher": false,
        "team": {
          "id": "video-health",
          "name": "Video Health",
          "channels": {
            "slack-help": "help-tech-coblicam"
          }
        }
      },
      {
        "id": "identificacao-facial-root",
        "url": "/camera/images",
        "page": {
          "title": {
            "pt-BR": "Identificação facial ",
            "en-US": "Facial Identification"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/identificacao-facial",
          "favorite": true,
          "description": {
            "pt-BR": "Confira as imagens de identificação facial capturadas",
            "en-US": "Check captured facial identification images"
          }
        },
        "tabs": [
          {
            "id": "historico-identificacao-facial",
            "url": "/camera/images",
            "page": {
              "title": {
                "pt-BR": "Identificação facial",
                "en-US": "Facial Identification"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/identificacao-facial",
              "favorite": true,
              "description": {
                "pt-BR": "Confira as imagens de identificação facial capturadas",
                "en-US": "Check captured facial identification images"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "title": {
                "pt-BR": "Identificação facial",
                "en-US": "Facial Identification"
              },
              "active": false
            },
            "permission": "update:driver-face-cluster",
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          },
          {
            "id": "todas-as-fotos",
            "url": "/camera/images/all",
            "page": {
              "title": {
                "pt-BR": "Identificação facial",
                "en-US": "All Photos"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/identificacao-facial",
              "favorite": true,
              "description": {
                "pt-BR": "Confira as imagens de identificação facial capturadas",
                "en-US": "Check captured facial identification images"
              }
            },
            "header": {
              "filterGroup": false
            },
            "sidebar": {
              "title": {
                "pt-BR": "Identificação facial",
                "en-US": "Facial Identification"
              },
              "active": false
            },
            "permission": "update:driver-face-cluster",
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          }
        ],
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "hide": false,
          "icon": "contact-round",
          "title": {
            "pt-BR": "Identificação facial",
            "en-US": "Facial Identification"
          },
          "active": false
        },
        "permission": "update:driver-face-cluster",
        "hasCameraFlag": true,
        "isSafetyCoacher": false,
        "team": {
          "id": "video-xp",
          "name": "Video XP",
          "channels": {
            "slack-help": "help-tech-coblicam"
          }
        }
      },
      {
        "id": "video-wall",
        "url": "/livestream",
        "page": {
          "title": {
            "pt-BR": "Vídeo Wall",
            "en-US": "Video Wall"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/ver-ao-vivo-e-video-wall",
          "favorite": true,
          "description": {
            "pt-BR": "Visualize ao vivo múltiplas câmeras simultaneamente",
            "en-US": "View multiple cameras live simultaneously"
          }
        },
        "tabs": [
          {
            "id": "new-tab-1749212287923",
            "page": {
              "title": {
                "pt-BR": "Nova Aba",
                "en-US": "New Tab"
              },
              "description": {
                "pt-BR": "Visualize ao vivo múltiplas câmeras simultaneamente",
                "en-US": "View multiple cameras live simultaneously"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/ver-ao-vivo-e-video-wall"
            },
            "sidebar": {
              "title": {
                "pt-BR": "Nova Aba",
                "en-US": "New Tab"
              }
            },
            "permission": "view:camera-media",
            "team": {
              "id": "video-health",
              "name": "Video Health",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          }
        ],
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "hide": false,
          "icon": "cctv",
          "title": {
            "pt-BR": "Vídeo Wall",
            "en-US": "Video Wall"
          },
          "active": false
        },
        "permission": "view:camera-media",
        "featureFlag": "livestreamPage",
        "hasCameraFlag": true,
        "isSafetyCoacher": false,
        "team": {
          "id": "video-health",
          "name": "Video Health",
          "channels": {
            "slack-help": "help-tech-coblicam"
          }
        }
      },
      {
        "id": "saude-das-cameras",
        "url": "/camera/health",
        "page": {
          "title": {
            "pt-BR": "Saúde das câmeras",
            "en-US": "Camera Health"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/saude-das-cameras",
          "favorite": true,
          "description": {
            "pt-BR": "Monitore os status e funcionamento das câmeras da frota",
            "en-US": "Monitor the status and operation of fleet cameras"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "hide": false,
          "icon": "monitor-stop",
          "title": {
            "pt-BR": "Saúde das câmeras",
            "en-US": "Camera Health"
          },
          "active": false
        },
        "permission": "view:camera-media",
        "featureFlag": "showObstructionDashboard",
        "hasCameraFlag": true,
        "isSafetyCoacher": false,
        "team": {
          "id": "video-health",
          "name": "Video Health",
          "channels": {
            "slack-help": "help-tech-coblicam"
          }
        }
      },
      {
        "id": "revisao-de-imagens",
        "url": "/match-review",
        "page": {
          "title": {
            "pt-BR": "Revisão de imagens",
            "en-US": "Image Review"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/cobli-cam/revisao-de-imagens"
        },
        "sidebar": {
          "hide": false,
          "icon": "image",
          "title": {
            "pt-BR": "Revisão de imagens",
            "en-US": "Image Review"
          },
          "active": false
        },
        "permission": "view:camera-media",
        "featureFlag": "showMatchReview",
        "team": {
          "id": "video-xp",
          "name": "Video XP",
          "channels": {
            "slack-help": "help-tech-coblicam"
          }
        }
      },
      {
        "id": "ranking-de-conducao-root",
        "url": "/safety-ranking",
        "page": {
          "infoUrl": "https://manual.cobli.co/docs/painel/seguranca/ranking-de-conducao",
          "description": {
            "pt-BR": "Acompanhe as melhores pontuações de segurança dos veículos e motoristas da frota",
            "en-US": "Track the best safety scores for fleet vehicles and drivers"
          },
          "favorite": true,
          "title": {
            "pt-BR": "Ranking de condução",
            "en-US": "Driving Ranking"
          }
        },
        "tabs": [
          {
            "id": "ranking-de-conducao-veiculo",
            "url": "/safety-ranking/ranking/vehicle",
            "page": {
              "title": {
                "pt-BR": "Ranking de condução",
                "en-US": "Driving Ranking"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/seguranca/ranking-de-conducao",
              "favorite": true,
              "description": {
                "pt-BR": "Acompanhe as melhores pontuações de segurança dos veículos e motoristas da frota",
                "en-US": "Track the best safety scores for fleet vehicles and drivers"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "title": {
                "pt-BR": "Ranking de condução",
                "en-US": "Driving Ranking"
              },
              "active": false
            },
            "permission": "view:fleet-safety",
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          },
          {
            "id": "ranking-de-conducao-motorista",
            "url": "/safety-ranking/ranking/driver",
            "page": {
              "title": {
                "pt-BR": "Ranking de condução",
                "en-US": "Driving Ranking"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/seguranca/ranking-de-conducao",
              "favorite": true,
              "description": {
                "pt-BR": "Acompanhe as melhores pontuações de segurança dos veículos e motoristas da frota",
                "en-US": "Track the best safety scores for fleet vehicles and drivers"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "title": {
                "pt-BR": "Ranking de condução",
                "en-US": "Driving Ranking"
              },
              "active": false
            },
            "permission": "view:fleet-safety",
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          }
        ],
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "ranking-parameters",
            "url": "/safety-ranking/parameters",
            "page": {
              "title": {
                "pt-BR": "Parametrizar nota",
                "en-US": "Parameterize Score"
              },
              "favorite": true,
              "description": {
                "pt-BR": "Altere a parametros para calibrar eventos e nota do ranking",
                "en-US": "Change parameters to calibrate events and ranking score"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/seguranca/ranking-de-conducao"
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Ranking de condução",
                "en-US": "Driving Ranking"
              },
              "active": false
            },
            "permission": "write:fleet-safety",
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "list-ordered",
          "title": {
            "pt-BR": "Ranking de condução",
            "en-US": "Driving Ranking"
          },
          "active": false
        },
        "redirect": "/safety-ranking/ranking/vehicle",
        "permission": "view:fleet-safety",
        "team": {
          "id": "video-xp",
          "name": "Video XP",
          "channels": {
            "slack-help": "help-tech-coblicam"
          }
        }
      },
      {
        "id": "velocidade",
        "url": "/speeding",
        "page": {
          "title": {
            "pt-BR": "Velocidade",
            "en-US": "Speed"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/seguranca/eventos-de-velocidade",
          "favorite": true,
          "description": {
            "pt-BR": "Monitoramento e análise de eventos de excesso de velocidade",
            "en-US": "Monitoring and analysis of speeding events"
          }
        },
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "road-speed",
            "url": "/road-speed",
            "page": {
              "title": {
                "pt-BR": "Limites de velocidade das vias",
                "en-US": "Road Speed Limits"
              },
              "description": {
                "pt-BR": "Cadastre novas velocidades da via para trechos e rodovias.",
                "en-US": "Register new road speeds for stretches and highways."
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/seguranca/eventos-de-velocidade"
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Ajustes de Velocidade",
                "en-US": "Speed Adjustments"
              }
            },
            "permission": "basic:permission",
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "gauge",
          "title": {
            "pt-BR": "Velocidade",
            "en-US": "Speed"
          },
          "active": false
        },
        "permission": "view:fleet-safety",
        "team": {
          "id": "video-xp",
          "name": "Video XP",
          "channels": {
            "slack-help": "help-tech-coblicam"
          }
        }
      },
      {
        "id": "tratativas",
        "url": "/coaching",
        "redirect": "/coaching/ongoing",
        "page": {
          "title": {
            "pt-BR": "Tratativas de ocorrências",
            "en-US": "Occurrence Handling"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/seguranca/tratativas-de-ocorrencias",
          "favorite": true,
          "description": {
            "pt-BR": "Gerenciamento de tratativas de ocorrências identificadas na frota",
            "en-US": "Management of handling of occurrences identified in the fleet"
          }
        },
        "tabs": [
          {
            "id": "tratativas-em-andamento",
            "url": "/coaching/ongoing",
            "page": {
              "title": {
                "pt-BR": "Tratativas de ocorrências",
                "en-US": "Occurrence Handling"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/seguranca/tratativas-de-ocorrencias",
              "description": {
                "pt-BR": "Gerenciamento de tratativas de ocorrências identificadas na frota",
                "en-US": "Management of handling of occurrences identified in the fleet"
              },
              "favorite": true
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "active": false
            },
            "permission": "request:camera-media",
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          },
          {
            "id": "tratativas-concluidas",
            "url": "/coaching/finished",
            "page": {
              "title": {
                "pt-BR": "Tratativas de ocorrências",
                "en-US": "Occurrence Handling"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/seguranca/tratativas-de-ocorrencias",
              "favorite": true,
              "description": {
                "pt-BR": "Gerenciamento de tratativas de ocorrências identificadas na frota",
                "en-US": "Management of handling of occurrences identified in the fleet"
              }
            },
            "header": {
              "filterGroup": false
            },
            "sidebar": {
              "hide": true,
              "active": false
            },
            "permission": "request:camera-media",
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          }
        ],
        "routes": [
          {
            "id": "detalhes-da-tratativa",
            "url": "/coaching/:coachingId",
            "page": {
              "title": {
                "pt-BR": "Detalhes da tratativa",
                "en-US": "Handling Details"
              },
              "favorite": true,
              "infoUrl": "https://manual.cobli.co/docs/painel/seguranca/tratativas-de-ocorrencias"
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "active": false
            },
            "permission": "request:camera-media",
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          }
        ],
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "hide": false,
          "active": false,
          "icon": "clipboard-list",
          "title": {
            "pt-BR": "Tratativas",
            "en-US": "Handling"
          }
        },
        "permission": "request:camera-media",
        "hasCameraFlag": true,
        "team": {
          "id": "video-xp",
          "name": "Video XP",
          "channels": {
            "slack-help": "help-tech-coblicam"
          }
        }
      }
    ],
    "sidebar": {
      "icon": "shield-alert",
      "title": {
        "pt-BR": "Segurança",
        "en-US": "Security"
      },
      "active": false
    },
    "redirect": "/safety/dashboard/ranking/driver",
    "permission": "basic:permission",
    "team": {
      "id": "video-xp",
      "name": "Video XP",
      "channels": {
        "slack-help": "help-tech-coblicam"
      }
    }
  },
  {
    "id": "efficiency",
    "page": {
      "title": {
        "pt-BR": "Eficiência",
        "en-US": "Efficiency"
      },
      "infoUrl": "https://cobli.com.br",
      "favorite": true,
      "description": {
        "pt-BR": "Análise de eficiência operacional e produtividade da frota",
        "en-US": "Analysis of operational efficiency and fleet productivity"
      }
    },
    "header": {
      "filterGroup": true
    },
    "routes": [
      {
        "id": "produtividade-root",
        "url": "",
        "page": {
          "title": {
            "pt-BR": "Produtividade",
            "en-US": "Productivity"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/produtividade",
          "favorite": true,
          "description": {
            "pt-BR": "Análise de eficiência operacional e produtividade da frota",
            "en-US": "Analysis of operational efficiency and fleet productivity"
          }
        },
        "tabs": [
          {
            "id": "analise-de-produtividade",
            "url": "/productivity/dashboard",
            "page": {
              "title": {
                "pt-BR": "Análise de produtividade",
                "en-US": "Productivity Analysis"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/produtividade/analisar-produtividade",
              "favorite": true,
              "description": {
                "pt-BR": "Visão geral das métricas de produtividade",
                "en-US": "Overview of productivity metrics"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Produtividade",
                "en-US": "Productivity"
              },
              "active": false
            },
            "permission": "view:analytics-and-reports",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "produtividade-por-grupo",
            "url": "/productivity/dashboard/vehicle-group",
            "page": {
              "title": {
                "pt-BR": "Análise por grupo",
                "en-US": "Analysis by Group"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/produtividade/analisar-produtividade",
              "favorite": true,
              "description": {
                "pt-BR": "Análise de produtividade organizada por grupos de veículos",
                "en-US": "Productivity analysis organized by vehicle groups"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Produtividade",
                "en-US": "Productivity"
              },
              "active": false
            },
            "permission": "view:analytics-and-reports",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "produtividade-legacy",
            "url": "/productivity/legacy",
            "page": {
              "title": {
                "pt-BR": "Produtividade geral",
                "en-US": "General Productivity"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/produtividade/analisar-produtividade",
              "favorite": true,
              "description": {
                "pt-BR": "Versão anterior do dashboard de produtividade",
                "en-US": "Previous version of the productivity dashboard"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Produtividade",
                "en-US": "Productivity"
              },
              "active": false
            },
            "permission": "view:analytics-and-reports",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "trending-up",
          "title": {
            "pt-BR": "Produtividade",
            "en-US": "Productivity"
          },
          "active": false
        },
        "redirect": "/productivity/dashboard",
        "permission": "view:analytics-and-reports",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "conducao-economica-root",
        "url": "",
        "page": {
          "title": {
            "pt-BR": "Condução econômica",
            "en-US": "Economic Driving"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/conducao-economica",
          "favorite": true,
          "description": {
            "pt-BR": "Condução econômica, reduza os custos operacionais da sua frota",
            "en-US": "Economic driving, reduce the operational costs of your fleet"
          }
        },
        "tabs": [
          {
            "id": "analise-de-conducao-economica",
            "url": "/economic-driving/dashboard",
            "page": {
              "title": {
                "pt-BR": "Condução econômica",
                "en-US": "Economic Driving"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/conducao-economica",
              "favorite": true,
              "description": {
                "pt-BR": "Visão geral da eficiência operacional da frota, disponível apenas para veículos com rede CAN",
                "en-US": "Overview of the fleet's operational efficiency, available only for vehicles with a CAN network"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Condução econômica",
                "en-US": "Economic Driving"
              },
              "active": false
            },
            "permission": "view:analytics-and-reports",
            "hasRedeCan": true,
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "conducao-economica-por-motorista",
            "url": "/economic-driving/dashboard/driver",
            "page": {
              "title": {
                "pt-BR": "Condução econômica",
                "en-US": "Economic Driving"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/conducao-economica",
              "favorite": true,
              "description": {
                "pt-BR": "Visão geral da eficiência operacional da frota, disponível apenas para veículos com rede CAN",
                "en-US": "Overview of the fleet's operational efficiency, available only for vehicles with a CAN network"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Condução econômica",
                "en-US": "Economic Driving"
              },
              "active": false
            },
            "permission": "view:analytics-and-reports",
            "hasRedeCan": true,
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "economic-driving-dashboard-vehicle",
            "url": "/economic-driving/dashboard/vehicle",
            "page": {
              "title": {
                "pt-BR": "Condução Econômica",
                "en-US": "Economic Driving"
              },
              "favorite": true,
              "description": {
                "pt-BR": "Visão geral da eficiência operacional da frota, disponível apenas para veículos com rede CAN",
                "en-US": "Overview of the fleet's operational efficiency, available only for vehicles with a CAN network"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/conducao-economica"
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Condução Econômica",
                "en-US": "Economic Driving"
              }
            },
            "permission": "view:analytics-and-reports",
            "hasRedeCan": true,
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "hide": false,
          "icon": "traffic-cone",
          "title": {
            "pt-BR": "Condução econômica",
            "en-US": "Economic Driving"
          },
          "active": false
        },
        "redirect": "/economic-driving/dashboard",
        "permission": "view:analytics-and-reports",
        "hasRedeCan": true,
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "despesas-operacionais",
        "url": "",
        "page": {
          "title": {
            "pt-BR": "Despesas",
            "en-US": "Expenses"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/despesas-e-custos",
          "favorite": true,
          "description": {
            "pt-BR": "Gerencie e acompanhe as despesas operacionais da sua frota.",
            "en-US": "Manage and track your fleet's operational expenses."
          }
        },
        "tabs": [
          {
            "id": "despesas-operacionais-historico",
            "url": "/expenses/history",
            "page": {
              "title": {
                "pt-BR": "Despesas",
                "en-US": "Expenses"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/despesas-e-custos",
              "favorite": true,
              "description": {
                "pt-BR": "Gerencie e acompanhe as despesas operacionais da sua frota.",
                "en-US": "Manage and track your fleet's operational expenses."
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "dollar-sign",
              "title": {
                "pt-BR": "Despesas",
                "en-US": "Expenses"
              },
              "active": false
            },
            "permission": "view:fleet-expenses",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "despesas-operacionais-veiculo",
            "url": "/expenses/vehicle",
            "page": {
              "title": {
                "pt-BR": "Despesas",
                "en-US": "Expenses"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/despesas-e-custos",
              "favorite": true,
              "description": {
                "pt-BR": "Gerencie e acompanhe as despesas operacionais da sua frota.",
                "en-US": "Manage and track your fleet's operational expenses."
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "dollar-sign",
              "title": {
                "pt-BR": "Despesas",
                "en-US": "Expenses"
              },
              "active": false
            },
            "permission": "view:fleet-expenses",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "dollar-sign",
          "title": {
            "pt-BR": "Despesas",
            "en-US": "Expenses"
          },
          "active": false
        },
        "redirect": "/expenses/history",
        "permission": "view:fleet-expenses",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "combustivel",
        "url": "/fuel-card/dashboard",
        "page": {
          "title": {
            "pt-BR": "Combustível",
            "en-US": "Fuel"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/combustivel",
          "favorite": true,
          "description": {
            "pt-BR": "Monitore o combustível dos seus veículos.",
            "en-US": "Monitor the fuel of your vehicles."
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "fuel",
          "title": {
            "pt-BR": "Combustível",
            "en-US": "Fuel"
          },
          "active": false
        },
        "tabs": [
          {
            "id": "combustivel-total-por-veiculo",
            "url": "/fuel-card/total-by-vehicle",
            "page": {
              "title": {
                "pt-BR": "Combustível",
                "en-US": "Fuel"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/combustivel",
              "favorite": true,
              "description": {
                "pt-BR": "Monitore o combustível dos seus veículos.",
                "en-US": "Monitor the fuel of your vehicles."
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "fuel",
              "title": {
                "pt-BR": "Combustível",
                "en-US": "Fuel"
              },
              "active": false
            },
            "permission": "view:fuel-card",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "combustivel-historico-transacoes",
            "url": "/fuel-card/transaction-history",
            "page": {
              "title": {
                "pt-BR": "Combustível",
                "en-US": "Fuel"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/combustivel",
              "favorite": true,
              "description": {
                "pt-BR": "Monitore o combustível dos seus veículos.",
                "en-US": "Monitor the fuel of your vehicles."
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "fuel",
              "title": {
                "pt-BR": "Combustível",
                "en-US": "Fuel"
              },
              "active": false
            },
            "permission": "view:fuel-card",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "combustivel-associacao-cartoes",
            "url": "/fuel-card/card-associations",
            "page": {
              "title": {
                "pt-BR": "Combustível",
                "en-US": "Fuel"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/combustivel",
              "favorite": true,
              "description": {
                "pt-BR": "Monitore o combustível dos seus veículos.",
                "en-US": "Monitor the fuel of your vehicles."
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "fuel",
              "title": {
                "pt-BR": "Combustível",
                "en-US": "Fuel"
              },
              "active": false
            },
            "permission": "view:fuel-card",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "permission": "view:fuel-card",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "manutencao-root",
        "url": "",
        "page": {
          "title": {
            "pt-BR": "Manutenção",
            "en-US": "Maintenance"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/manutencao",
          "favorite": true,
          "description": {
            "pt-BR": "Faça análises, acompanhe alertas e o histórico da sua frota.",
            "en-US": "Perform analysis, track alerts and the history of your fleet."
          }
        },
        "tabs": [
          {
            "id": "dashboard-de-manutencao",
            "url": "/maintenance/dashboard",
            "page": {
              "title": {
                "pt-BR": "Manutenção",
                "en-US": "Maintenance"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/manutencao",
              "favorite": true,
              "description": {
                "pt-BR": "Faça análises, acompanhe alertas e o histórico da sua frota.",
                "en-US": "Perform analysis, track alerts and the history of your fleet."
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "title": {
                "pt-BR": "Manutenção",
                "en-US": "Maintenance"
              },
              "active": false
            },
            "permission": "full-control:maintenance",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "lembretes-de-manutencao",
            "url": "/maintenance/reminders",
            "page": {
              "title": {
                "pt-BR": "Manutenção",
                "en-US": "Maintenance"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/manutencao",
              "favorite": true,
              "description": {
                "pt-BR": "Faça análises, acompanhe alertas e o histórico de consumo de combustível da sua frota.",
                "en-US": "Perform analysis, track alerts and the fuel consumption history of your fleet."
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "title": {
                "pt-BR": "Manutenção",
                "en-US": "Maintenance"
              },
              "active": false
            },
            "permission": "full-control:maintenance",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "historico-de-manutencao",
            "url": "/maintenance/history",
            "page": {
              "title": {
                "pt-BR": "Manutenção",
                "en-US": "Maintenance"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/manutencao",
              "favorite": true,
              "description": {
                "pt-BR": "Faça análises, acompanhe alertas e o histórico de consumo de combustível da sua frota.",
                "en-US": "Perform analysis, track alerts and the fuel consumption history of your fleet."
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "title": {
                "pt-BR": "Manutenção",
                "en-US": "Maintenance"
              },
              "active": false
            },
            "permission": "full-control:maintenance",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "wrench",
          "title": {
            "pt-BR": "Manutenção",
            "en-US": "Maintenance"
          },
          "active": false
        },
        "redirect": "/maintenance/dashboard",
        "permission": "full-control:maintenance",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "multas",
        "url": "/fines",
        "page": {
          "title": {
            "pt-BR": "Multas",
            "en-US": "Traffic Fines"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/multas",
          "favorite": true,
          "description": {
            "pt-BR": "Gerencie e acompanhe as multas da sua frota.",
            "en-US": "Manage and track your fleet's traffic fines."
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "receipt",
          "title": {
            "pt-BR": "Multas",
            "en-US": "Traffic Fines"
          },
          "active": false
        },
        "permission": "view:fleet-expenses",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      }
    ],
    "sidebar": {
      "icon": "trending-up",
      "title": {
        "pt-BR": "Eficiência",
        "en-US": "Efficiency"
      },
      "active": false
    },
    "redirect": "/productivity/dashboard",
    "permission": "basic:permission",
    "team": {
      "id": "gf-core",
      "name": "GF-Core",
      "channels": {
        "slack-help": "help-tech-gf-core"
      }
    }
  },
  {
    "id": "reports",
    "page": {
      "title": {
        "pt-BR": "Relatórios",
        "en-US": "Reports"
      },
      "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
      "favorite": true,
      "description": {
        "pt-BR": "Sistema completo de relatórios operacionais e analíticos da frota",
        "en-US": "Complete system of operational and analytical fleet reports"
      }
    },
    "header": {
      "filterGroup": true
    },
    "routes": [
      {
        "id": "visao-geral-relatorios",
        "url": "/report/home",
        "page": {
          "title": {
            "pt-BR": "Visão geral",
            "en-US": "Overview"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
          "favorite": true,
          "description": {
            "pt-BR": "Dashboard com visão geral dos principais relatórios",
            "en-US": "Dashboard with an overview of the main reports"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "layout-dashboard",
          "title": {
            "pt-BR": "Visão Geral",
            "en-US": "Overview"
          },
          "active": false
        },
        "permission": "view:analytics-and-reports",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "motor-ocioso",
        "url": "/report/idle-engine",
        "page": {
          "title": {
            "pt-BR": "Motor ocioso",
            "en-US": "Idle Engine"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
          "favorite": true,
          "description": {
            "pt-BR": "Analise o tempo de parada dos veículos da frota com o motor ligado.",
            "en-US": "Analyze the idle time of fleet vehicles with the engine on."
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "timer-off",
          "title": {
            "pt-BR": "Motor Ocioso",
            "en-US": "Idle Engine"
          },
          "active": false
        },
        "permission": "view:analytics-and-reports",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "fora-de-jornada",
        "url": "/report/out-journey",
        "page": {
          "title": {
            "pt-BR": "Atividade fora do horário de trabalho",
            "en-US": "After-Hours Activity"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
          "favorite": true,
          "description": {
            "pt-BR": "Relatório de períodos em que veículos estiveram fora da jornada de trabalho",
            "en-US": "Report of periods when vehicles were outside of working hours"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "calendar-x",
          "title": {
            "pt-BR": "Fora do horário",
            "en-US": "After Hours"
          },
          "active": false
        },
        "permission": "view:analytics-and-reports",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "chaveiros-sem-identificacao",
        "url": "/report/identifier-association",
        "page": {
          "title": {
            "pt-BR": "Chaveiros sem identificação",
            "en-US": "Key fobs without identification"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
          "favorite": true,
          "description": {
            "pt-BR": "Relatório de chaveiros não associados a motoristas identificados",
            "en-US": "Report of key fobs not associated with identified drivers"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "fingerprint",
          "title": {
            "pt-BR": "Chaveiros",
            "en-US": "Key fobs"
          },
          "active": false
        },
        "permission": "view:analytics-and-reports",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "rotas-e-pontos",
        "url": "/report/routes-points",
        "page": {
          "title": {
            "pt-BR": "Ponto a ponto",
            "en-US": "Point to Point"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
          "favorite": true,
          "description": {
            "pt-BR": "Análise detalhada de rotas percorridas e pontos de interesse",
            "en-US": "Detailed analysis of routes taken and points of interest"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "waypoints",
          "title": {
            "pt-BR": "Ponto a ponto",
            "en-US": "Point to Point"
          },
          "active": false
        },
        "permission": "view:analytics-and-reports",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "distancia-percorrida",
        "url": "/report/distance-driven",
        "page": {
          "title": {
            "pt-BR": "Distância percorrida",
            "en-US": "Distance Traveled"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
          "favorite": true,
          "description": {
            "pt-BR": "Relatório de quilometragem total percorrida pelos veículos",
            "en-US": "Report of total mileage traveled by vehicles"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "move-horizontal",
          "title": {
            "pt-BR": "Distância percorrida",
            "en-US": "Distance Traveled"
          },
          "active": false
        },
        "permission": "view:analytics-and-reports",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "locais-de-interesse",
        "url": "/report/geofence-events",
        "support": {
          "uid": "criando-locais-de-interesse"
        },
        "page": {
          "title": {
            "pt-BR": "Locais de interesse",
            "en-US": "Points of Interest"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/geofences/historico-de-passagens",
          "favorite": true,
          "description": {
            "pt-BR": "Relatório de eventos em locais de interesse e geofences",
            "en-US": "Report of events at points of interest and geofences"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "map-pin-off",
          "title": {
            "pt-BR": "Locais de interesse",
            "en-US": "Points of Interest"
          },
          "active": false
        },
        "permission": "view:analytics-and-reports",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "incidentes",
        "url": "/report/incident",
        "page": {
          "title": {
            "pt-BR": "Incidentes",
            "en-US": "Incidents"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
          "favorite": true,
          "description": {
            "pt-BR": "Relatório detalhado de incidentes ocorridos com a frota",
            "en-US": "Detailed report of incidents that occurred with the fleet"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "triangle-alert",
          "title": {
            "pt-BR": "Incidentes",
            "en-US": "Incidents"
          },
          "active": false
        },
        "permission": "view:analytics-and-reports",
        "team": {
          "id": "video-xp",
          "name": "Video XP",
          "channels": {
            "slack-help": "help-tech-coblicam"
          }
        }
      },
      {
        "id": "dashboards-personalizados",
        "url": "/report/custom-dashboards",
        "page": {
          "title": {
            "pt-BR": "Dashboards Personalizados",
            "en-US": "Custom Dashboards"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
          "favorite": true,
          "description": {
            "pt-BR": "Lista de dashboards personalizados",
            "en-US": "List of custom dashboards"
          }
        },
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "dashboard-detalhes",
            "url": "/report/custom-dashboards/:externalDashboardId",
            "page": {
              "title": {
                "pt-BR": "Dashboard Personalizado",
                "en-US": "Custom Dashboard"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
              "favorite": true,
              "description": ""
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Dashboard",
                "en-US": "Dashboard"
              },
              "active": false
            },
            "permission": "view:analytics-and-reports",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "layout-dashboard",
          "title": {
            "pt-BR": "Dashboards",
            "en-US": "Custom Dashboards"
          },
          "active": false
        },
        "permission": "view:analytics-and-reports",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "eventos-de-seguranca",
        "page": {
          "title": {
            "pt-BR": "Eventos de segurança",
            "en-US": "Security Events"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
          "favorite": true,
          "description": {
            "pt-BR": "Relatórios detalhados de eventos de segurança da frota",
            "en-US": "Detailed reports of fleet security events"
          }
        },
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "visao-geral-de-seguranca",
            "url": "/report/safety/vehicle",
            "page": {
              "title": {
                "pt-BR": "Eventos de segurança - Veículo",
                "en-US": "Security Events - Vehicle"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
              "favorite": true,
              "description": {
                "pt-BR": "Relatório resumido com eventos de segurança por veículo",
                "en-US": "Summary report with security events by vehicle"
              }
            },
            "tabs": [
              {
                "id": "visao-geral-de-seguranca-veiculo",
                "url": "/report/safety/vehicle",
                "page": {
                  "title": {
                    "pt-BR": "Eventos de segurança - Veículo",
                    "en-US": "Security Events - Vehicle"
                  },
                  "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
                  "favorite": true,
                  "description": {
                    "pt-BR": "Relatório resumido com eventos de segurança por veículo",
                    "en-US": "Summary report with security events by vehicle"
                  }
                },
                "header": {
                  "filterGroup": true
                },
                "sidebar": {
                  "hide": true,
                  "title": {
                    "pt-BR": "Resumo",
                    "en-US": "Summary"
                  },
                  "active": false
                },
                "permission": "view:analytics-and-reports",
                "team": {
                  "id": "video-xp",
                  "name": "Video XP",
                  "channels": {
                    "slack-help": "help-tech-coblicam"
                  }
                }
              },
              {
                "id": "visao-geral-de-seguranca-motorista",
                "url": "/report/safety/driver",
                "page": {
                  "title": {
                    "pt-BR": "Eventos de segurança - Motorista",
                    "en-US": "Security Events - Driver"
                  },
                  "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
                  "favorite": true,
                  "description": {
                    "pt-BR": "Relatório resumido com eventos de segurança por motorista",
                    "en-US": "Summary report with security events by driver"
                  }
                },
                "header": {
                  "filterGroup": true
                },
                "sidebar": {
                  "hide": true,
                  "title": {
                    "pt-BR": "Resumo",
                    "en-US": "Summary"
                  },
                  "active": false
                },
                "permission": "view:analytics-and-reports",
                "team": {
                  "id": "video-xp",
                  "name": "Video XP",
                  "channels": {
                    "slack-help": "help-tech-coblicam"
                  }
                }
              }
            ],
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "layout-dashboard",
              "title": {
                "pt-BR": "Resumo",
                "en-US": "Summary"
              },
              "active": false
            },
            "permission": "view:analytics-and-reports",
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          },
          {
            "id": "eventos-detalhados",
            "url": "/report/safety-event",
            "page": {
              "title": {
                "pt-BR": "Eventos detalhados",
                "en-US": "Detailed Events"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
              "favorite": true,
              "description": {
                "pt-BR": "Relatório detalhado de todos os eventos de segurança",
                "en-US": "Detailed report of all security events"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "file-text",
              "title": {
                "pt-BR": "Detalhados",
                "en-US": "Detailed"
              },
              "active": false
            },
            "permission": "view:analytics-and-reports",
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "shield-check",
          "title": {
            "pt-BR": "Eventos de segurança",
            "en-US": "Security Events"
          },
          "active": false
        },
        "permission": "view:fleet-safety",
        "team": {
          "id": "video-xp",
          "name": "Video XP",
          "channels": {
            "slack-help": "help-tech-coblicam"
          }
        }
      },
      {
        "id": "associacoes-root",
        "page": {
          "title": {
            "pt-BR": "Associações",
            "en-US": "Associations"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
          "favorite": true,
          "description": {
            "pt-BR": "Relatórios de associações entre motoristas, veículos e dispositivos",
            "en-US": "Reports of associations between drivers, vehicles and devices"
          }
        },
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "motorista-veiculo",
            "url": "/report/driver-vehicle-association",
            "page": {
              "title": {
                "pt-BR": "Motorista-Veículo",
                "en-US": "Driver-Vehicle"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
              "favorite": true,
              "description": {
                "pt-BR": "Relatório de associações entre motoristas e veículos",
                "en-US": "Report of associations between drivers and vehicles"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "user-round",
              "title": {
                "pt-BR": "Motorista-Veículo",
                "en-US": "Driver-Vehicle"
              },
              "active": false
            },
            "permission": "view:analytics-and-reports",
            "team": {
              "id": "account-experience",
              "name": "Account Experience",
              "channels": {
                "slack-help": "help-tech-account-xp"
              }
            }
          },
          {
            "id": "veiculo-dispositivo-root",
            "url": "/report/vehicle-device-association/device",
            "page": {
              "title": {
                "pt-BR": "Veículo-Dispositivo",
                "en-US": "Vehicle-Device"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
              "favorite": true,
              "description": {
                "pt-BR": "Relatório de associações entre veículos e dispositivos de rastreamento",
                "en-US": "Report of associations between vehicles and tracking devices"
              }
            },
            "tabs": [
              {
                "id": "associacao-por-dispositivo",
                "url": "/report/vehicle-device-association/device",
                "page": {
                  "title": {
                    "pt-BR": "Veículo-Dispositivo",
                    "en-US": "Vehicle-Device"
                  },
                  "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
                  "favorite": true,
                  "description": {
                    "pt-BR": "Relatório de associações entre veículos e dispositivos de rastreamento",
                    "en-US": "Report of associations between vehicles and tracking devices"
                  }
                },
                "header": {
                  "filterGroup": true
                },
                "sidebar": {
                  "hide": true,
                  "title": {
                    "pt-BR": "Veículo-Dispositivo",
                    "en-US": "Vehicle-Device"
                  },
                  "active": false
                },
                "permission": "view:analytics-and-reports",
                "team": {
                  "id": "account-experience",
                  "name": "Account Experience",
                  "channels": {
                    "slack-help": "help-tech-account-xp"
                  }
                }
              },
              {
                "id": "associacao-por-veiculo",
                "url": "/report/vehicle-device-association/vehicle",
                "page": {
                  "title": {
                    "pt-BR": "Veículo-Dispositivo",
                    "en-US": "Vehicle-Device"
                  },
                  "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
                  "favorite": true,
                  "description": {
                    "pt-BR": "Relatório de associações entre veículos e dispositivos de rastreamento",
                    "en-US": "Report of associations between vehicles and tracking devices"
                  }
                },
                "header": {
                  "filterGroup": true
                },
                "sidebar": {
                  "hide": true,
                  "title": {
                    "pt-BR": "Veículo-Dispositivo",
                    "en-US": "Vehicle-Device"
                  },
                  "active": false
                },
                "permission": "view:analytics-and-reports",
                "team": {
                  "id": "account-experience",
                  "name": "Account Experience",
                  "channels": {
                    "slack-help": "help-tech-account-xp"
                  }
                }
              }
            ],
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "router",
              "title": {
                "pt-BR": "Veículo-Dispositivo",
                "en-US": "Vehicle-Device"
              },
              "active": false
            },
            "permission": "view:analytics-and-reports",
            "team": {
              "id": "account-experience",
              "name": "Account Experience",
              "channels": {
                "slack-help": "help-tech-account-xp"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "link-2",
          "title": {
            "pt-BR": "Associações",
            "en-US": "Associations"
          },
          "active": false
        },
        "permission": "view:analytics-and-reports",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "trajetos-e-paradas",
        "page": {
          "title": {
            "pt-BR": "Trajetos e paradas",
            "en-US": "Trips and Stops"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
          "favorite": true,
          "description": {
            "pt-BR": "Relatórios detalhados de trajetos realizados e paradas da frota",
            "en-US": "Detailed reports of trips taken and fleet stops"
          }
        },
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "visao-geral-de-trajetos",
            "url": "/report/trip-and-stop/vehicle",
            "page": {
              "title": {
                "pt-BR": "Trajetos e paradas",
                "en-US": "Trips and Stops"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
              "favorite": true,
              "description": {
                "pt-BR": "Relatório resumido dos trajetos e paradas da frota",
                "en-US": "Summary report of fleet trips and stops"
              }
            },
            "tabs": [
              {
                "id": "visao-geral-de-trajetos-veiculo",
                "url": "/report/trip-and-stop/vehicle",
                "page": {
                  "title": {
                    "pt-BR": "Trajetos e paradas",
                    "en-US": "Trips and Stops"
                  },
                  "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
                  "favorite": true,
                  "description": {
                    "pt-BR": "Relatório resumido dos trajetos e paradas da frota",
                    "en-US": "Summary report of fleet trips and stops"
                  }
                },
                "header": {
                  "filterGroup": true
                },
                "sidebar": {
                  "hide": true,
                  "title": {
                    "pt-BR": "Resumo",
                    "en-US": "Summary"
                  },
                  "active": false
                },
                "permission": "view:analytics-and-reports",
                "team": {
                  "id": "gf-core",
                  "name": "GF-Core",
                  "channels": {
                    "slack-help": "help-tech-gf-core"
                  }
                }
              },
              {
                "id": "visao-geral-de-trajetos-motorista",
                "url": "/report/trip-and-stop/driver",
                "page": {
                  "title": {
                    "pt-BR": "Trajetos e paradas",
                    "en-US": "Trips and Stops"
                  },
                  "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
                  "favorite": true,
                  "description": {
                    "pt-BR": "Relatório resumido dos trajetos e paradas da frota",
                    "en-US": "Summary report of fleet trips and stops"
                  }
                },
                "header": {
                  "filterGroup": true
                },
                "sidebar": {
                  "hide": true,
                  "title": {
                    "pt-BR": "Resumo",
                    "en-US": "Summary"
                  },
                  "active": false
                },
                "permission": "view:analytics-and-reports",
                "team": {
                  "id": "gf-core",
                  "name": "GF-Core",
                  "channels": {
                    "slack-help": "help-tech-gf-core"
                  }
                }
              }
            ],
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "layout-dashboard",
              "title": {
                "pt-BR": "Resumo",
                "en-US": "Summary"
              },
              "active": false
            },
            "permission": "view:analytics-and-reports",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "relatorio-diario",
            "url": "/report/trip-and-stop/vehicle/daily",
            "page": {
              "title": {
                "pt-BR": "Trajetos e paradas diário",
                "en-US": "Daily Trips and Stops"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
              "favorite": true,
              "description": {
                "pt-BR": "Relatório diário detalhado dos trajetos e paradas da frota",
                "en-US": "Detailed daily report of fleet trips and stops"
              }
            },
            "tabs": [
              {
                "id": "relatorio-diario-veiculo",
                "url": "/report/trip-and-stop/vehicle/daily",
                "page": {
                  "title": {
                    "pt-BR": "Trajetos e paradas diário",
                    "en-US": "Daily Trips and Stops"
                  },
                  "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
                  "favorite": true,
                  "description": {
                    "pt-BR": "Relatório diário detalhado dos trajetos e paradas da frota",
                    "en-US": "Detailed daily report of fleet trips and stops"
                  }
                },
                "header": {
                  "filterGroup": true
                },
                "sidebar": {
                  "hide": true,
                  "title": {
                    "pt-BR": "Diário",
                    "en-US": "Daily"
                  },
                  "active": false
                },
                "permission": "view:analytics-and-reports",
                "team": {
                  "id": "gf-core",
                  "name": "GF-Core",
                  "channels": {
                    "slack-help": "help-tech-gf-core"
                  }
                }
              },
              {
                "id": "relatorio-diario-motorista",
                "url": "/report/trip-and-stop/driver/daily",
                "page": {
                  "title": {
                    "pt-BR": "Trajetos e paradas diário",
                    "en-US": "Daily Trips and Stops"
                  },
                  "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
                  "favorite": true,
                  "description": {
                    "pt-BR": "Relatório diário detalhado dos trajetos e paradas da frota",
                    "en-US": "Detailed daily report of fleet trips and stops"
                  }
                },
                "header": {
                  "filterGroup": false
                },
                "sidebar": {
                  "hide": true,
                  "title": {
                    "pt-BR": "Diário",
                    "en-US": "Daily"
                  },
                  "active": false
                },
                "permission": "view:analytics-and-reports",
                "team": {
                  "id": "gf-core",
                  "name": "GF-Core",
                  "channels": {
                    "slack-help": "help-tech-gf-core"
                  }
                }
              }
            ],
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "calendar-x",
              "title": {
                "pt-BR": "Diário",
                "en-US": "Daily"
              },
              "active": false
            },
            "permission": "view:analytics-and-reports",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "relatorio-detalhado",
            "url": "/report/trip-and-stop/details",
            "page": {
              "title": {
                "pt-BR": "Trajetos e paradas detalhado",
                "en-US": "Detailed Trips and Stops"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/relatorios",
              "favorite": true,
              "description": {
                "pt-BR": "Relatório com informações detalhadas de cada trajeto e parada da frota",
                "en-US": "Report with detailed information of each trip and stop of the fleet"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "file-text",
              "title": {
                "pt-BR": "Detalhado",
                "en-US": "Detailed"
              },
              "active": false
            },
            "permission": "view:analytics-and-reports",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "route",
          "title": {
            "pt-BR": "Trajetos e paradas",
            "en-US": "Trips and Stops"
          },
          "active": false
        },
        "permission": "view:analytics-and-reports",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      }
    ],
    "sidebar": {
      "icon": "file-chart-column-increasing",
      "title": {
        "pt-BR": "Relatórios",
        "en-US": "Reports"
      },
      "active": false
    },
    "redirect": "/report/home",
    "permission": "view:analytics-and-reports",
    "team": {
      "id": "gf-core",
      "name": "GF-Core",
      "channels": {
        "slack-help": "help-tech-gf-core"
      }
    }
  },
  {
    "id": "my-fleet",
    "page": {
      "title": {
        "pt-BR": "Minha Frota",
        "en-US": "My Fleet"
      },
      "infoUrl": "https://cobli.com.br",
      "favorite": true,
      "description": {
        "pt-BR": "Gestão completa dos recursos da frota: veículos, motoristas e dispositivos",
        "en-US": "Complete management of fleet resources: vehicles, drivers, and devices"
      }
    },
    "header": {
      "filterGroup": true
    },
    "routes": [
      {
        "id": "veiculos",
        "url": "/vehicles",
        "support": {
          "uid": "pagina-de-veiculos",
          "relations": [
            "como-resolver-veiculos-rodando-sem-motoristas"
          ]
        },
        "page": {
          "title": {
            "pt-BR": "Veículos",
            "en-US": "Vehicles"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/veiculos",
          "favorite": true,
          "description": {
            "pt-BR": "Cadastro e gestão de todos os veículos da frota",
            "en-US": "Registration and management of all fleet vehicles"
          }
        },
        "header": {
          "filterGroup": true
        },
        "tabs": [
          {
            "id": "veiculos-todos",
            "url": "/vehicles",
            "page": {
              "title": {
                "pt-BR": "Veículos",
                "en-US": "Vehicles"
              },
              "favorite": true,
              "description": {
                "pt-BR": "Cadastro e gestão de todos os veículos da frota",
                "en-US": "Registration and management of all fleet vehicles"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/veiculos"
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Veículos",
                "en-US": "Vehicles"
              },
              "active": false
            },
            "permission": "basic:permission",
            "team": {
              "id": "account-experience",
              "name": "Account Experience",
              "channels": {
                "slack-help": "help-tech-account-xp"
              }
            }
          },
          {
            "id": "veiculos-rodando-sem-motorista",
            "url": "/vehicles/running-without-driver",
            "page": {
              "title": {
                "pt-BR": "Veículos",
                "en-US": "Vehicles"
              },
              "favorite": true,
              "description": {
                "pt-BR": "Veículos com rostos capturados ainda não associados a um motorista",
                "en-US": "Vehicles with captured faces not yet associated with a driver"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/veiculos"
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Veículos",
                "en-US": "Vehicles"
              },
              "active": false
            },
            "permission": "basic:permission",
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-video-xp"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "truck",
          "title": {
            "pt-BR": "Veículos",
            "en-US": "Vehicles"
          },
          "active": false
        },
        "permission": "basic:permission",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "grupos-de-veiculos",
        "url": "/groups",
        "page": {
          "title": {
            "pt-BR": "Grupos de veículos",
            "en-US": "Vehicle Groups"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/grupos-de-veiculos",
          "favorite": true,
          "description": {
            "pt-BR": "Organização de veículos em grupos para melhor gestão",
            "en-US": "Organization of vehicles into groups for better management"
          }
        },
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "group-new",
            "url": "/groups/new",
            "page": {
              "title": {
                "pt-BR": "Grupos de veículos",
                "en-US": "New Group"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/grupos-de-veiculos",
              "favorite": true,
              "description": {
                "pt-BR": "Organização de veículos em grupos para melhor gestão",
                "en-US": "Organization of vehicles into groups for better management"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Novo grupo",
                "en-US": "New group"
              }
            },
            "permission": "basic:permission",
            "team": {
              "id": "account-experience",
              "name": "Account Experience",
              "channels": {
                "slack-help": "help-tech-account-xp"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "group",
          "title": {
            "pt-BR": "Grupos de veículos",
            "en-US": "Vehicle Groups"
          },
          "active": false
        },
        "permission": "basic:permission",
        "support": {
          "uid": "pagina-de-grupos-de-veiculos"
        },
        "isSafetyCoacher": false,
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "dispositivos",
        "url": "/devices",
        "support": {
          "uid": "pagina-de-dispositivos"
        },
        "page": {
          "title": {
            "pt-BR": "Dispositivos",
            "en-US": "Devices"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/dispositivos",
          "favorite": true,
          "description": {
            "pt-BR": "Gestão dos dispositivos da frota",
            "en-US": "Management of fleet devices"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "router",
          "title": {
            "pt-BR": "Dispositivos",
            "en-US": "Devices"
          },
          "active": false
        },
        "permission": "basic:permission",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "motoristas",
        "url": "/driver-management",
        "page": {
          "title": {
            "pt-BR": "Motoristas",
            "en-US": "Drivers"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/motoristas",
          "favorite": true,
          "description": {
            "pt-BR": "Cadastro e gestão de motoristas da frota",
            "en-US": "Registration and management of fleet drivers"
          }
        },
        "support": {
          "uid": "pagina-de-motoristas"
        },
        "tabs": [
          {
            "id": "motoristas-visao-geral",
            "url": "/driver-management",
            "page": {
              "title": {
                "pt-BR": "Motoristas",
                "en-US": "Drivers"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/motoristas",
              "favorite": true,
              "description": {
                "pt-BR": "Cadastro e gestão de motoristas da frota",
                "en-US": "Registration and management of fleet drivers"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Motoristas",
                "en-US": "Drivers"
              },
              "active": false
            },
            "permission": "basic:permission",
            "team": {
              "id": "account-experience",
              "name": "Account Experience",
              "channels": {
                "slack-help": "help-tech-account-xp"
              }
            }
          },
          {
            "id": "motoristas-identificados",
            "url": "/driver-management/list",
            "page": {
              "title": {
                "pt-BR": "Motoristas",
                "en-US": "Drivers"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/motoristas",
              "favorite": true,
              "description": {
                "pt-BR": "Cadastro e gestão de motoristas da frota",
                "en-US": "Registration and management of fleet drivers"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Motoristas",
                "en-US": "Drivers"
              },
              "active": false
            },
            "permission": "basic:permission"
          },
          {
            "id": "motoristas-nao-identificados",
            "url": "/driver-management/not-identified",
            "page": {
              "title": {
                "pt-BR": "Motoristas",
                "en-US": "Drivers"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/motoristas",
              "favorite": true,
              "description": {
                "pt-BR": "Cadastro e gestão de motoristas da frota",
                "en-US": "Registration and management of fleet drivers"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Motoristas",
                "en-US": "Drivers"
              },
              "active": false
            },
            "permission": "view:camera-media",
            "team": {
              "id": "account-experience",
              "name": "Account Experience",
              "channels": {
                "slack-help": "help-tech-account-xp"
              }
            }
          }
        ],
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "users-round",
          "title": {
            "pt-BR": "Motoristas",
            "en-US": "Drivers"
          },
          "active": false
        },
        "permission": "basic:permission",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "identificadores",
        "url": "/identifiers",
        "hasIdentifiers": true,
        "page": {
          "title": {
            "pt-BR": "Identificadores",
            "en-US": "Identifiers"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/identificadores",
          "favorite": true,
          "description": {
            "pt-BR": "Gestão de identificadores RFID e iButton da frota",
            "en-US": "Management of fleet RFID and iButton identifiers"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "key-round",
          "title": {
            "pt-BR": "Identificadores",
            "en-US": "Identifiers"
          },
          "active": false
        },
        "permission": "create-update-delete:driver",
        "team": {
          "id": "gf-core",
          "name": "GF-Core",
          "channels": {
            "slack-help": "help-tech-gf-core"
          }
        }
      },
      {
        "id": "pedidos",
        "url": "/orders",
        "support": {
          "uid": "pedidos"
        },
        "page": {
          "title": {
            "pt-BR": "Pedidos",
            "en-US": "Orders"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/pedidos",
          "favorite": true,
          "description": {
            "pt-BR": "Gerencie pedidos, agendamentos e devoluções de dispositivos",
            "en-US": "Manage orders, schedules, and device returns"
          }
        },
        "routes": [
          {
            "id": "order-details",
            "url": "/orders/details/:orderId",
            "page": {
              "title": {
                "pt-BR": "Detalhes do pedido",
                "en-US": "Order details"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/pedidos",
              "favorite": true,
              "description": ""
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "hide": true,
              "title": {
                "pt-BR": "Detalhes do pedido",
                "en-US": "Order details"
              },
              "active": false
            },
            "permission": "create-update-delete:crm",
            "team": {
              "id": "account-experience",
              "name": "Account Experience",
              "channels": {
                "slack-help": "help-tech-account-xp"
              }
            }
          }
        ],
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "package",
          "title": {
            "pt-BR": "Pedidos",
            "en-US": "Orders"
          },
          "active": false
        },
        "permission": "create-update-delete:crm",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      }
    ],
    "sidebar": {
      "icon": "truck",
      "title": {
        "pt-BR": "Minha Frota",
        "en-US": "My Fleet"
      },
      "active": false
    },
    "redirect": "/vehicles",
    "permission": "basic:permission",
    "team": {
      "id": "account-experience",
      "name": "Account Experience",
      "channels": {
        "slack-help": "help-tech-account-xp"
      }
    }
  },
  {
    "id": "colib-showcase",
    "url": "/colib-showcase",
    "redirect": "/colib-showcase",
    "isDev": true,
    "permission": "basic:permission",
    "page": {
      "title": {
        "pt-BR": "Colib UI",
        "en-US": "Colib UI"
      },
      "description": {
        "pt-BR": "Mostruário dos componentes do design system Colib.",
        "en-US": "Colib design system component showcase."
      },
      "favorite": false
    },
    "sidebar": {
      "icon": "palette",
      "title": {
        "pt-BR": "Colib UI",
        "en-US": "Colib UI"
      },
      "active": false
    },
    "header": {
      "filterGroup": false
    }
  },
  {
    "id": "config",
    "url": "",
    "page": {
      "title": {
        "pt-BR": "Configurações",
        "en-US": "Settings"
      },
      "infoUrl": "https://manual.cobli.co/docs/painel/administracao",
      "favorite": false,
      "description": {
        "pt-BR": "Gerencie a segurança da sua frota",
        "en-US": "Manage your fleet's settings"
      }
    },
    "header": {
      "filterGroup": false
    },
    "sidebar": {
      "onlyIcon": true,
      "icon": "settings",
      "title": {
        "pt-BR": "Configurações",
        "en-US": "Settings"
      },
      "active": false
    },
    "redirect": "/config/account",
    "permission": "basic:permission",
    "hasCameraFlag": false,
    "hasGroupsRestriction": true,
    "routes": [
      {
        "id": "account",
        "url": "/config/account",
        "page": {
          "title": {
            "pt-BR": "Minha conta",
            "en-US": "My Account"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/administracao/minha-conta",
          "favorite": true,
          "description": {
            "pt-BR": "Configurações pessoais da conta do usuário",
            "en-US": "Personal user account settings"
          }
        },
        "header": {
          "filterGroup": false
        },
        "sidebar": {
          "icon": "user",
          "title": {
            "pt-BR": "Minha conta",
            "en-US": "My Account"
          },
          "active": false
        },
        "permission": "basic:permission",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "users",
        "url": "/config/users",
        "page": {
          "title": {
            "pt-BR": "Usuários",
            "en-US": "Users"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/administracao/usuarios",
          "favorite": true,
          "description": {
            "pt-BR": "Usuários e permissões da frota\n",
            "en-US": "Fleet users and permissions\n"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "user-round",
          "title": {
            "pt-BR": "Usuários",
            "en-US": "Users"
          }
        },
        "redirect": "",
        "permission": "view:users-and-invites",
        "hasGroupsRestriction": true,
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "notificacoes",
        "url": "/config/notifications-center",
        "page": {
          "title": {
            "pt-BR": "Central de Notificação",
            "en-US": "Notification Center"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/administracao/central-de-notificacoes",
          "favorite": true,
          "description": {
            "pt-BR": "Configure os canais de notificação",
            "en-US": "Configure notification channels"
          }
        },
        "sidebar": {
          "icon": "message-square-text",
          "title": {
            "pt-BR": "Notificações",
            "en-US": "Notifications"
          },
          "active": false
        },
        "permission": "basic:permission",
        "hasGroupsRestriction": true,
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "config-sound-alerts",
        "url": "/config/alerts",
        "page": {
          "title": {
            "pt-BR": "Avisos sonoros",
            "en-US": "Sound Alerts"
          },
          "description": {
            "pt-BR": "Garanta que seus motoristas tenham feedbacks sonoros imediatos na cabine.",
            "en-US": "Ensure your drivers have immediate sound feedback in the cabin."
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/administracao/avisos-sonoros"
        },
        "sidebar": {
          "icon": "megaphone",
          "title": {
            "pt-BR": "Avisos sonoros",
            "en-US": "Sound Alerts"
          }
        },
        "permission": "basic:permission",
        "team": {
          "id": "iot-telematics",
          "name": "IoT Telematics",
          "channels": {
            "slack-help": "help-tech-iot"
          }
        }
      },
      {
        "id": "cobli-cam",
        "url": "",
        "page": {
          "title": {
            "pt-BR": "Cobli Cam",
            "en-US": "Cobli Cam"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/administracao/cobli-cam",
          "favorite": true,
          "description": {
            "pt-BR": "Visualize os vídeos das câmeras da frota e gerencie as configurações",
            "en-US": "View fleet camera videos and manage settings"
          }
        },
        "routes": [
          {
            "id": "config-wifi-cameras",
            "url": "/config/camera-wifi-configuration",
            "page": {
              "title": {
                "pt-BR": "Configuração de Wi-Fi para as câmeras",
                "en-US": "Wi-Fi Configuration for Cameras"
              },
              "favorite": true,
              "description": {
                "pt-BR": "Configure as redes de Wi-Fi das câmeras da frota",
                "en-US": "Configure Wi-Fi networks for fleet cameras"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/administracao/cobli-cam"
            },
            "sidebar": {
              "icon": "wifi",
              "title": {
                "pt-BR": "Wi-Fi",
                "en-US": "Wi-Fi"
              }
            },
            "permission": "basic:permission",
            "featureFlag": "disableWifiConfiguration",
            "hasCameraFlag": true,
            "hasGroupsRestriction": true,
            "team": {
              "id": "video-health",
              "name": "Video Health",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          },
          {
            "id": "config-events-camera",
            "url": "/config/events-configuration",
            "page": {
              "title": {
                "pt-BR": "Configurações de Eventos",
                "en-US": "Event Settings"
              },
              "description": {
                "pt-BR": "Defina os tipos de evento e o nível de sensibilidade das câmeras",
                "en-US": "Define event types and camera sensitivity level"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/administracao/cobli-cam"
            },
            "sidebar": {
              "icon": "sliders-vertical",
              "title": {
                "pt-BR": "Eventos",
                "en-US": "Events"
              }
            },
            "permission": "basic:permission",
            "hasCameraFlag": true,
            "hasGroupsRestriction": true,
            "team": {
              "id": "video-health",
              "name": "Video Health",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          },
          {
            "id": "config-face-id",
            "url": "/config/face-id",
            "page": {
              "title": {
                "pt-BR": "Configuração de identificação facial",
                "en-US": "Face identification settings"
              },
              "description": {
                "pt-BR": "Defina preferências relacionadas a associação de motoristas por identificação facial",
                "en-US": "Configure preferences related to driver association by face identification"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/administracao/cobli-cam"
            },
            "sidebar": {
              "icon": "scan-face",
              "title": {
                "pt-BR": "Identificação facial",
                "en-US": "Face Identification"
              }
            },
            "permission": "basic:permission",
            "hasCameraFlag": true,
            "hasGroupsRestriction": true,
            "team": {
              "id": "video-xp",
              "name": "Video XP",
              "channels": {
                "slack-help": "help-tech-coblicam"
              }
            }
          }
        ],
        "sidebar": {
          "hide": false,
          "icon": "megaphone",
          "title": {
            "pt-BR": "Cobli Cam",
            "en-US": "Cobli Cam"
          }
        },
        "permission": "basic:permission",
        "hasCameraFlag": true,
        "hasGroupsRestriction": true,
        "isSafetyCoacher": false,
        "team": {
          "id": "video-health",
          "name": "Video Health",
          "channels": {
            "slack-help": "help-tech-coblicam"
          }
        }
      },
      {
        "id": "integrations",
        "url": "",
        "page": {
          "title": {
            "pt-BR": "Integrações",
            "en-US": "Integrations"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/administracao/integracoes",
          "favorite": false,
          "description": {
            "pt-BR": "Gerencie as integrações da sua frota",
            "en-US": "Manage your fleet integrations"
          }
        },
        "header": {
          "filterGroup": false
        },
        "routes": [
          {
            "id": "aplicativos",
            "url": "/apps",
            "page": {
              "title": {
                "pt-BR": "Aplicativos",
                "en-US": "Apps"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/administracao/integracoes",
              "favorite": true,
              "description": {
                "pt-BR": "Gestão de aplicativos móveis e integração com apps externos",
                "en-US": "Mobile app management and integration with external apps"
              }
            },
            "header": {
              "filterGroup": false
            },
            "sidebar": {
              "icon": "phone",
              "title": {
                "pt-BR": "Aplicativos",
                "en-US": "Apps"
              },
              "active": false
            },
            "permission": "administrate:api-integrations",
            "team": {
              "id": "account-experience",
              "name": "Account Experience",
              "channels": {
                "slack-help": "help-tech-account-xp"
              }
            }
          },
          {
            "id": "apis",
            "url": "/apis",
            "page": {
              "title": {
                "pt-BR": "Chaves de API",
                "en-US": "API Keys"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/administracao/integracoes",
              "favorite": true,
              "description": {
                "pt-BR": "Configuração e gestão de integrações via API",
                "en-US": "API integration configuration and management"
              }
            },
            "header": {
              "filterGroup": false
            },
            "sidebar": {
              "icon": "key-round",
              "title": {
                "pt-BR": "Chaves de API",
                "en-US": "API Keys"
              },
              "active": false
            },
            "permission": "administrate:api-integrations",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          },
          {
            "id": "webhooks",
            "url": "/webhooks",
            "page": {
              "title": {
                "pt-BR": "Webhooks",
                "en-US": "Webhooks"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/administracao/integracoes",
              "favorite": true,
              "description": {
                "pt-BR": "Configuração de webhooks para notificações automáticas",
                "en-US": "Webhook configuration for automatic notifications"
              }
            },
            "header": {
              "filterGroup": false
            },
            "sidebar": {
              "icon": "webhook",
              "title": {
                "pt-BR": "Webhooks",
                "en-US": "Webhooks"
              },
              "active": false
            },
            "permission": "administrate:api-integrations",
            "team": {
              "id": "gf-core",
              "name": "GF-Core",
              "channels": {
                "slack-help": "help-tech-gf-core"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "workflow",
          "title": {
            "pt-BR": "Integrações",
            "en-US": "Integrations"
          },
          "active": false
        },
        "redirect": "/apps",
        "permission": "administrate:api-integrations",
        "featureFlag": "integrationsPage",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "financial",
        "featureFlag": "businessManager",
        "page": {
          "title": {
            "pt-BR": "Financeiro",
            "en-US": "Financial"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/administracao/financeiro",
          "favorite": true,
          "description": {
            "pt-BR": "Gerencie seus boletos e faturas",
            "en-US": "Manage your boletos and bills"
          }
        },
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "boletos",
            "url": "/business-manager/boletos",
            "permission": "write:hubspot-finance",
            "page": {
              "title": {
                "pt-BR": "Boletos e Notas Fiscais",
                "en-US": "Bills and Invoices"
              },
              "description": {
                "pt-BR": "Visualize boletos e notas fiscais",
                "en-US": "View boletos and invoices"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/administracao/financeiro",
              "favorite": true
            },
            "sidebar": {
              "icon": "dollar-sign",
              "title": {
                "pt-BR": "Boletos e Notas",
                "en-US": "Financial"
              },
              "active": false
            },
            "header": {
              "filterGroup": true
            },
            "team": {
              "id": "account-experience",
              "name": "Account Experience",
              "channels": {
                "slack-help": "help-tech-account-xp"
              }
            }
          },
          {
            "id": "contracts",
            "url": "/business-manager/contracts",
            "page": {
              "title": {
                "pt-BR": "Contratos",
                "en-US": "Contracts and Invoices"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/administracao/financeiro",
              "favorite": true,
              "description": {
                "pt-BR": "Gerencie seus contratos e dados financeiros",
                "en-US": "Manage your contracts and financial data"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "file-text",
              "title": {
                "pt-BR": "Contratos",
                "en-US": "Contracts and Invoices"
              },
              "active": false,
              "externalLink": true
            },
            "permission": "read:hubspot-contracts",
            "isSafetyCoacher": false,
            "team": {
              "id": "account-experience",
              "name": "Account Experience",
              "channels": {
                "slack-help": "help-tech-account-xp"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "house",
          "title": {
            "pt-BR": "Financeiro",
            "en-US": "Financial"
          },
          "active": false
        },
        "permission": "write:hubspot-finance",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      }
    ],
    "team": {
      "id": "account-experience",
      "name": "Account Experience",
      "channels": {
        "slack-help": "help-tech-account-xp"
      }
    }
  },
  {
    "id": "customer-area",
    "featureFlag": "businessManager",
    "permission": "basic:permission",
    "hasCameraFlag": false,
    "hasRedeCan": false,
    "hasGroupsRestriction": false,
    "isSafetyCoacher": false,
    "page": {
      "title": {
        "pt-BR": "Área do cliente",
        "en-US": "Customer Area"
      },
      "description": {
        "pt-BR": "Gerencie seus tickets de suporte, contratos e financeiro",
        "en-US": "Manage your support tickets, contracts and financial"
      },
      "infoUrl": "https://manual.cobli.co/docs/painel/area-do-cliente",
      "favorite": true
    },
    "sidebar": {
      "icon": "house",
      "title": {
        "pt-BR": "Área do cliente",
        "en-US": "Customer Area"
      },
      "active": false,
      "hide": true,
      "onlyIcon": false
    },
    "header": {
      "filterGroup": true
    },
    "routes": [
      {
        "id": "area-do-cliente",
        "url": "/business-manager",
        "page": {
          "title": {
            "pt-BR": "Visão geral",
            "en-US": "Customer Area"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/area-do-cliente/visao-geral",
          "favorite": true,
          "description": {
            "pt-BR": "Visão geral de tickets, contratos e financeiro",
            "en-US": "Overview of tickets, contracts and financial"
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "icon": "layout-dashboard",
          "title": {
            "pt-BR": "Visão Geral",
            "en-US": "Support Center"
          },
          "active": false
        },
        "permission": "basic:permission",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "tickets",
        "page": {
          "title": {
            "pt-BR": "Suporte",
            "en-US": "Support"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/area-do-cliente/suporte",
          "favorite": true,
          "description": {
            "pt-BR": "Gerencie seus tickets de suporte, contratos e financeiro",
            "en-US": "Manage your support tickets, contracts and financial"
          }
        },
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "tickets",
            "url": "/business-manager/ticket",
            "page": {
              "title": {
                "pt-BR": "Tickets de suporte",
                "en-US": "Support tickets"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/area-do-cliente/suporte",
              "favorite": false,
              "description": {
                "pt-BR": "Gerencie seus tickets de suporte",
                "en-US": "Manage your support tickets"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "message-square",
              "title": {
                "pt-BR": "Tickets de suporte",
                "en-US": "Support tickets"
              },
              "active": false
            },
            "permission": "basic:permission",
            "team": {
              "id": "account-experience",
              "name": "Account Experience",
              "channels": {
                "slack-help": "help-tech-account-xp"
              }
            }
          },
          {
            "id": "tickets-details",
            "url": "/business-manager/ticket-detail",
            "page": {
              "title": {
                "pt-BR": "Tickets Detalhes",
                "en-US": "Details Ticket"
              },
              "favorite": false,
              "infoUrl": "https://manual.cobli.co/docs/painel/area-do-cliente/suporte"
            },
            "sidebar": {
              "active": false,
              "hide": true,
              "onlyIcon": false
            },
            "header": {
              "filterGroup": false
            },
            "permission": "basic:permission",
            "team": {
              "id": "account-experience",
              "name": "Account Experience",
              "channels": {
                "slack-help": "help-tech-account-xp"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "message-square",
          "title": {
            "pt-BR": "Atendimento",
            "en-US": "Support"
          },
          "active": false
        },
        "permission": "basic:permission",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "financial",
        "page": {
          "title": {
            "pt-BR": "Financeiro",
            "en-US": "Financial"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/area-do-cliente/financeiro",
          "favorite": true,
          "description": {
            "pt-BR": "Gerencie seus boletos e faturas",
            "en-US": "Manage your boletos and bills"
          }
        },
        "header": {
          "filterGroup": true
        },
        "routes": [
          {
            "id": "boletos",
            "url": "/business-manager/boletos",
            "page": {
              "title": {
                "pt-BR": "Boletos e Notas Fiscais",
                "en-US": "Bills and Invoices"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/area-do-cliente/financeiro",
              "favorite": true,
              "description": {
                "pt-BR": "Visualize boletos e notas fiscais",
                "en-US": "View boletos and invoices"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "dollar-sign",
              "title": {
                "pt-BR": "Boletos e Notas",
                "en-US": "Financial"
              },
              "active": false
            },
            "permission": "write:hubspot-finance",
            "team": {
              "id": "account-experience",
              "name": "Account Experience",
              "channels": {
                "slack-help": "help-tech-account-xp"
              }
            }
          },
          {
            "id": "contracts",
            "url": "/business-manager/contracts",
            "page": {
              "title": {
                "pt-BR": "Contratos",
                "en-US": "Contracts and Invoices"
              },
              "infoUrl": "https://manual.cobli.co/docs/painel/area-do-cliente/financeiro",
              "favorite": true,
              "description": {
                "pt-BR": "Gerencie seus contratos e dados financeiros",
                "en-US": "Manage your contracts and financial data"
              }
            },
            "header": {
              "filterGroup": true
            },
            "sidebar": {
              "icon": "file-text",
              "title": {
                "pt-BR": "Contratos",
                "en-US": "Contracts and Invoices"
              },
              "active": false
            },
            "permission": "read:hubspot-contracts",
            "isSafetyCoacher": false,
            "team": {
              "id": "account-experience",
              "name": "Account Experience",
              "channels": {
                "slack-help": "help-tech-account-xp"
              }
            }
          }
        ],
        "sidebar": {
          "icon": "house",
          "title": {
            "pt-BR": "Financeiro",
            "en-US": "Financial"
          },
          "active": false
        },
        "permission": "write:hubspot-finance",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      }
    ],
    "team": {
      "id": "account-experience",
      "name": "Account Experience",
      "channels": {
        "slack-help": "help-tech-account-xp"
      }
    }
  },
  {
    "id": "others",
    "url": "",
    "page": {
      "title": {
        "pt-BR": "Outros",
        "en-US": "Others"
      },
      "infoUrl": "https://cobli.com.br",
      "favorite": true,
      "description": {
        "pt-BR": "Outras páginas",
        "en-US": "Other pages"
      }
    },
    "header": {
      "filterGroup": false
    },
    "routes": [
      {
        "id": "news",
        "url": "/news",
        "page": {
          "title": {
            "pt-BR": "Novidades",
            "en-US": "News"
          },
          "infoUrl": false,
          "favorite": true,
          "description": {
            "pt-BR": "Fique por dentro das últimas novidades e atualizações da Cobli.",
            "en-US": "Stay up to date with the latest news and updates from Cobli."
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "hide": true,
          "icon": "gift",
          "title": {
            "pt-BR": "Novidades",
            "en-US": "News"
          },
          "active": false
        },
        "redirect": "",
        "permission": "basic:permission",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "risk-notifications",
        "url": "/notifications",
        "featureFlag": "knockInApp",
        "page": {
          "title": {
            "pt-BR": "Notificações",
            "en-US": "Notifications"
          },
          "infoUrl": "https://manual.cobli.co/docs/painel/cobli-ia/reconhecimento-de-risco",
          "description": {
            "pt-BR": "Notificações de risco da frota detectadas pela IA.",
            "en-US": "Fleet risk notifications detected by AI."
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "hide": true,
          "icon": "message-square-warning",
          "title": {
            "pt-BR": "Notificações",
            "en-US": "Notifications"
          },
          "active": false
        },
        "redirect": "",
        "permission": "basic:permission",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      },
      {
        "id": "treinamento",
        "url": "/training",
        "page": {
          "title": {
            "pt-BR": "Treinamentos",
            "en-US": "Training"
          },
          "infoUrl": false,
          "favorite": true,
          "description": {
            "pt-BR": "Veja os vídeos de treinamento.",
            "en-US": "Watch the training videos."
          }
        },
        "header": {
          "filterGroup": true
        },
        "sidebar": {
          "hide": true,
          "icon": "circle",
          "title": {
            "pt-BR": "Treinamento",
            "en-US": "Training"
          },
          "active": false
        },
        "redirect": "",
        "permission": "basic:permission",
        "team": {
          "id": "account-experience",
          "name": "Account Experience",
          "channels": {
            "slack-help": "help-tech-account-xp"
          }
        }
      }
    ],
    "sidebar": {
      "hide": true,
      "icon": "settings",
      "title": {
        "pt-BR": "Outros (Hidden)",
        "en-US": "Others (Hidden)"
      },
      "active": false
    },
    "redirect": "/training",
    "permission": "basic:permission",
    "team": {
      "id": "account-experience",
      "name": "Account Experience",
      "channels": {
        "slack-help": "help-tech-account-xp"
      }
    }
  }
]
